"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ProductDetailModal = _interopRequireDefault(require("./ProductDetailModal"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * MenuCell - Composant d'affichage de menu de restaurant avec animations
 * @param {Array} products - Tableau de produits à afficher
 * @param {Object} styles_properties - Propriétés de style personnalisées
 *   - title: Titre du menu (string)
 *   - subtitle: Sous-titre personnalisé (string)
 *   - primaryColor: Couleur principale (string)
 *   - secondaryColor: Couleur secondaire (string)
 *   - accentColor: Couleur d'accent (string)
 *   - backgroundColor: Couleur de fond (string)
 *   - textColor: Couleur du texte (string)
 *   - fontFamily: Police de caractères (string)
 *   - titleFontSize: Taille du titre (string)
 *   - cardBorderRadius: Rayon des bordures des cartes (string)
 *   - cardBackground: Fond des cartes (string)
 *   - priceColor: Couleur des prix (string)
 *   - buttonText: Texte du bouton d'action (string)
 *   - searchPlaceholder: Placeholder du champ de recherche (string)
 *   - showPrice: Afficher les prix (boolean)
 *   - showDescription: Afficher les descriptions (boolean)
 *   - showTags: Afficher les tags (boolean)
 *   - showAllergens: Afficher les allergènes (boolean)
 *   - showNutriScore: Afficher le nutri-score (boolean)
 *   - showIngredients: Afficher les ingrédients (boolean)
 *   - imageHeight: Hauteur des images (string)
 *   - containerPadding: Padding du conteneur (string)
 *   - gridGap: Espacement entre les cartes (string)
 * @param {Function} onProductClick - Callback au clic sur un produit
 * @param {Function} uri_transformer - Transformateur d'URL pour les images
 */const MenuCell = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  template_name = 'default',
  scaleFactor = 1,
  logEvent,
  ...rest
}) => {
  // Sélection du template
  if (template_name === 'classic') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellClassic, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'moderne') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellModerne, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'prestige') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellPrestige, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'street') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellStreet, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'tropical') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellTropical, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'medieval') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellMedieval, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'light') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellLight, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'friterie') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellFriterie, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'pizzeria') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellPizzeria, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  if (template_name === 'patisserie') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellPatisserie, {
      products: products,
      styles_properties: styles_properties,
      onProductClick: onProductClick,
      uri_transformer: uri_transformer,
      showCategories: showCategories,
      showFilters: showFilters,
      layout: layout,
      columns: columns,
      scaleFactor: scaleFactor,
      logEvent: logEvent,
      ...rest
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuCellDefault, {
    products: products,
    styles_properties: styles_properties,
    onProductClick: onProductClick,
    uri_transformer: uri_transformer,
    showCategories: showCategories,
    showFilters: showFilters,
    layout: layout,
    columns: columns,
    scaleFactor: scaleFactor,
    logEvent: logEvent,
    ...rest
  });
};

// Helper pour fusionner les styles avec les propriétés personnalisées
const getCustomStyle = (baseStyle, customProps = {}) => ({
  ...baseStyle,
  ...customProps
});

// Helper pour convertir snake_case en camelCase et normaliser les styles_properties
const normalizeStylesProperties = (props = {}) => {
  const snakeToCamelMap = {
    primary_color: 'primaryColor',
    secondary_color: 'secondaryColor',
    accent_color: 'accentColor',
    background_color: 'backgroundColor',
    text_color: 'textColor',
    font_family: 'fontFamily',
    title_font_size: 'titleFontSize',
    card_border_radius: 'cardBorderRadius',
    card_background: 'cardBackground',
    price_color: 'priceColor',
    button_text: 'buttonText',
    search_placeholder: 'searchPlaceholder',
    show_price: 'showPrice',
    show_description: 'showDescription',
    show_tags: 'showTags',
    show_allergens: 'showAllergens',
    show_nutri_score: 'showNutriScore',
    show_ingredients: 'showIngredients',
    image_height: 'imageHeight',
    container_padding: 'containerPadding',
    grid_gap: 'gridGap',
    show_ornaments: 'showOrnaments',
    show_scan_lines: 'showScanLines',
    show_crown: 'showCrown',
    show_graffiti: 'showGraffiti',
    show_waves: 'showWaves',
    show_torches: 'showTorches',
    show_emoji: 'showEmoji',
    footer_text: 'footerText'
  };
  const normalized = {
    ...props
  };
  Object.entries(snakeToCamelMap).forEach(([snake, camel]) => {
    if (props[snake] !== undefined && props[camel] === undefined) {
      normalized[camel] = props[snake];
    }
  });
  return normalized;
};

// ============================================
// TEMPLATE DEFAULT (existant)
// ============================================
const MenuCellDefault = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  logEvent,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut
  const {
    title = 'Notre Menu',
    subtitle,
    primaryColor = '#667eea',
    secondaryColor = '#764ba2',
    accentColor = '#f093fb',
    backgroundColor,
    textColor = '#ffffff',
    fontFamily,
    titleFontSize = '3em',
    cardBorderRadius = '24px',
    cardBackground,
    priceColor = '#10b981',
    buttonText = 'Voir détails →',
    searchPlaceholder = 'Rechercher un produit...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '220px',
    containerPadding = '2.5em',
    gridGap = '2em'
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 80);
      });
    }, 100);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85BB2F',
      'C': '#FECB02',
      'D': '#EE8100',
      'E': '#E63E11'
    };
    return colors[score] || '#999';
  };

  // Styles dynamiques basés sur styles_properties
  // fontSize du conteneur définit la base pour tous les em à l'intérieur
  const dynamicContainerStyle = {
    ...containerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...titleStyle,
    fontSize: titleFontSize,
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 50%, ${accentColor} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  };
  const dynamicProductCardStyle = {
    ...productCardStyle,
    borderRadius: cardBorderRadius,
    ...(cardBackground && {
      background: cardBackground
    })
  };
  const dynamicProductImageContainerStyle = {
    ...productImageContainerStyle,
    height: imageHeight,
    background: `linear-gradient(135deg, ${primaryColor}26 0%, ${secondaryColor}26 100%)`
  };
  const dynamicFloatingPriceStyle = {
    ...floatingPriceStyle,
    background: `linear-gradient(135deg, ${priceColor} 0%, ${priceColor}dd 100%)`
  };
  const dynamicActionButtonStyle = {
    ...actionButtonStyle,
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`
  };
  const dynamicCategoryActiveStyle = {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    boxShadow: `0 4px 15px ${primaryColor}66`
  };
  const dynamicProductsGridStyle = {
    ...productsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} produit${filteredProducts.length > 1 ? 's' : ''} disponible${filteredProducts.length > 1 ? 's' : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframesCSS
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: headerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: dynamicTitleStyle,
        children: title
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: subtitleStyle,
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: searchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: searchIconStyle,
          children: "\uD83D\uDD0D"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: searchInputStyle
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: categoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        activeStyle: dynamicCategoryActiveStyle,
        primaryColor: primaryColor,
        children: "\uD83C\uDF74 Tous"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(CategoryButton, {
        logEvent: logEvent,
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 50,
        activeStyle: dynamicCategoryActiveStyle,
        primaryColor: primaryColor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "menu-products-scroll",
      style: productsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: emptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: emptyIconStyle,
          children: "\uD83C\uDF7D\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...emptyTitleStyle,
            background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          },
          children: "Aucun produit trouv\xE9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: emptyTextStyle,
          children: searchQuery ? "Essayez avec d'autres termes de recherche" : "Aucun produit disponible dans cette catégorie"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          logEvent: logEvent,
          styles_properties: {
            cardStyle: dynamicProductCardStyle,
            imageContainerStyle: dynamicProductImageContainerStyle,
            priceStyle: dynamicFloatingPriceStyle,
            buttonStyle: dynamicActionButtonStyle,
            buttonText,
            primaryColor,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients
          }
        }, product.id))
      })
    })]
  });
};

// Composant bouton de catégorie
const CategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  activeStyle = {},
  primaryColor = '#667eea',
  logEvent
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: () => {
      onClick();
      logEvent?.({
        type: 'menu_category_click',
        category_id: category.id
      });
    },
    style: {
      ...categoryTabStyle,
      ...(isActive ? activeStyle : {}),
      background: isActive ? activeStyle.background || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
      color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
      boxShadow: isActive ? activeStyle.boxShadow || `0 4px 15px ${primaryColor}66` : 'none',
      transform: mounted ? 'translateY(0)' : 'translateY(10px)',
      opacity: mounted ? 1 : 0
    },
    children: children
  });
};

// Composant carte produit avec carrousel d'images
const ProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  logEvent,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [imageTransition, setImageTransition] = (0, _react.useState)(false);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    cardStyle = productCardStyle,
    imageContainerStyle = productImageContainerStyle,
    priceStyle = floatingPriceStyle,
    buttonStyle = actionButtonStyle,
    buttonText = 'Voir détails →',
    primaryColor = '#667eea',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true
  } = styles_properties;

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setImageTransition(true);
        setTimeout(() => {
          setCurrentImageIndex(prev => (prev + 1) % images.length);
          setImageTransition(false);
        }, 200);
      }, 1500);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      // Reset to default image when not hovered
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1 && defaultIndex !== currentImageIndex) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...cardStyle,
      transform: isVisible ? isHovered ? 'translateY(-12px) scale(1.02)' : 'translateY(0) scale(1)' : 'translateY(40px) scale(0.95)',
      opacity: isVisible ? 1 : 0,
      boxShadow: isHovered ? '0 30px 60px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.1)' : '0 10px 30px rgba(0,0,0,0.2)',
      borderColor: isHovered ? `${primaryColor}4d` : 'rgba(255,255,255,0.06)'
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: () => {
      onClick();
      logEvent?.({
        type: 'menu_product_click',
        product_id: product.id
      });
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: imageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...productImageStyle,
            transform: isHovered ? 'scale(1.1)' : 'scale(1)',
            opacity: imageTransition ? 0.7 : 1,
            filter: isHovered ? 'brightness(1.1)' : 'brightness(1)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: imageOverlayStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: imagePlaceholderStyle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '2.67em'
          },
          children: "\uD83C\uDF7D\uFE0F"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: imageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...imageIndicatorStyle,
            background: i === currentImageIndex ? '#fff' : 'rgba(255,255,255,0.4)',
            transform: i === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
          }
        }, i))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: badgesContainerStyle,
        children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...badgeStyle,
            background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
            animation: 'pulse 2s infinite'
          },
          children: "\u2B50 Vedette"
        }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...badgeStyle,
            background: getNutriScoreColor(product.nutrition_score),
            fontWeight: '700'
          },
          children: product.nutrition_score
        })]
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...priceStyle,
          transform: isHovered ? 'translateY(0) scale(1.05)' : 'translateY(0) scale(1)'
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: productContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: productNameStyle,
        children: product.name
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: productDescriptionStyle,
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...tagStyle,
            animationDelay: `${i * 100}ms`
          },
          children: tag
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 3).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...allergenTagStyle,
            animationDelay: `${(product.tags?.length || 0 + i) * 100}ms`
          },
          title: allergen.description || '',
          children: [allergen.icon || '⚠️', " ", allergen.name || allergen]
        }, `allergen-${i}`)), showAllergens && product.allergens?.length > 3 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: allergenTagStyle,
          children: ["+", product.allergens.length - 3]
        })]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: ingredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            marginRight: '0.5em',
            opacity: 0.6
          },
          children: "\uD83E\uDD57"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: ingredientsTextStyle,
          children: [product.ingredients.slice(0, 4).join(' • '), product.ingredients.length > 4 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: actionButtonContainerStyle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          style: {
            ...buttonStyle,
            transform: isHovered ? 'scale(1.02)' : 'scale(1)',
            boxShadow: isHovered ? `0 8px 25px ${primaryColor}66` : 'none'
          },
          children: buttonText
        })
      })]
    }), isHovered && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: shineEffectStyle
    })]
  });
};

// Keyframes CSS pour les animations
const keyframesCSS = `
    @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }
    @keyframes shimmer {
        0% { left: -100%; }
        100% { left: 200%; }
    }
    @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
    }
    @keyframes glow {
        0%, 100% { box-shadow: 0 0 5px rgba(102, 126, 234, 0.5); }
        50% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.8); }
    }
    
    /* Scrollbar styling */
    .menu-products-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .menu-products-scroll::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }
    .menu-products-scroll::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }
    .menu-products-scroll::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }
`;

// Styles
const containerStyle = {
  fontFamily: "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
  background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%)',
  color: '#ffffff',
  height: '100%',
  padding: '2.5em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const productsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em'
};
const headerStyle = {
  marginBottom: '2.5em',
  position: 'relative',
  zIndex: 1
};
const titleStyle = {
  fontSize: '1.33em',
  fontWeight: '800',
  margin: '0 0 0.5em',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  letterSpacing: '-0.02em'
};
const subtitleStyle = {
  fontSize: '0.73em',
  color: 'rgba(255,255,255,0.5)',
  margin: 0,
  fontWeight: '400'
};
const searchContainerStyle = {
  position: 'relative',
  maxWidth: '450px',
  marginTop: '1.5em'
};
const searchInputStyle = {
  width: '100%',
  padding: '1.1em 1.1em 1.1em 3.2em',
  fontSize: '0.67em',
  color: '#fff',
  background: 'rgba(255,255,255,0.05)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '16px',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  backdropFilter: 'blur(10px)'
};
const searchIconStyle = {
  position: 'absolute',
  left: '1.1em',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '0.53em',
  opacity: 0.5
};
const categoriesContainerStyle = {
  display: 'flex',
  gap: '0.6em',
  overflowX: 'auto',
  marginBottom: '2.5em',
  padding: '0.75em',
  background: 'rgba(255,255,255,0.02)',
  borderRadius: '20px',
  border: '1px solid rgba(255,255,255,0.05)',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const categoryTabStyle = {
  padding: '0.85em 1.6em',
  fontSize: '0.63em',
  fontWeight: '500',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const productsGridStyle = {
  display: 'grid',
  gap: '2em'
};
const productCardStyle = {
  background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)',
  borderRadius: '24px',
  overflow: 'hidden',
  border: '1px solid rgba(255,255,255,0.06)',
  transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative'
};
const productImageContainerStyle = {
  position: 'relative',
  height: '220px',
  background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
  overflow: 'hidden'
};
const productImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
};
const imageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '50%',
  background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%)',
  pointerEvents: 'none'
};
const imagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  opacity: 0.3
};
const imageIndicatorsStyle = {
  position: 'absolute',
  bottom: '1em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '6px',
  zIndex: 2
};
const imageIndicatorStyle = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  transition: 'all 0.3s ease'
};
const badgesContainerStyle = {
  position: 'absolute',
  top: '1em',
  left: '1em',
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap',
  zIndex: 2
};
const badgeStyle = {
  padding: '0.4em 0.75em',
  fontSize: '0.47em',
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: '#fff',
  borderRadius: '8px',
  backdropFilter: 'blur(10px)'
};
const floatingPriceStyle = {
  position: 'absolute',
  bottom: '1em',
  right: '1em',
  padding: '0.6em 1em',
  fontSize: '0.53em',
  fontWeight: '700',
  color: '#fff',
  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  zIndex: 2
};
const productContentStyle = {
  padding: '1.5em',
  position: 'relative'
};
const productNameStyle = {
  fontSize: '0.87em',
  fontWeight: '600',
  margin: '0 0 0.5em',
  color: '#fff',
  letterSpacing: '-0.01em'
};
const productDescriptionStyle = {
  fontSize: '0.6em',
  color: 'rgba(255,255,255,0.55)',
  margin: '0 0 1em',
  lineHeight: 1.6,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};
const tagsContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap',
  marginBottom: '0.75em'
};
const tagStyle = {
  padding: '0.3em 0.7em',
  fontSize: '0.5em',
  color: 'rgba(255,255,255,0.7)',
  background: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '8px',
  transition: 'all 0.3s ease'
};
const allergenTagStyle = {
  padding: '0.3em 0.7em',
  fontSize: '0.5em',
  color: '#fbbf24',
  background: 'rgba(251, 191, 36, 0.12)',
  border: '1px solid rgba(251, 191, 36, 0.25)',
  borderRadius: '8px'
};
const ingredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  marginTop: '0.75em'
};
const ingredientsTextStyle = {
  fontSize: '0.53em',
  color: 'rgba(255,255,255,0.4)',
  fontStyle: 'italic'
};
const actionButtonContainerStyle = {
  marginTop: '1em',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
};
const actionButtonStyle = {
  width: '100%',
  padding: '0.85em',
  fontSize: '0.6em',
  fontWeight: '600',
  color: '#fff',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const shineEffectStyle = {
  position: 'absolute',
  top: 0,
  left: '-100%',
  width: '50%',
  height: '100%',
  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)',
  animation: 'shimmer 1.5s ease-in-out',
  pointerEvents: 'none'
};
const emptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center'
};
const emptyIconStyle = {
  fontSize: '3.33em',
  marginBottom: '1.5em',
  opacity: 0.3,
  animation: 'float 3s ease-in-out infinite'
};
const emptyTitleStyle = {
  fontSize: '0.53em',
  fontWeight: '600',
  margin: '0 0 0.75em',
  background: 'linear-gradient(135deg, #667eea, #764ba2)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
};
const emptyTextStyle = {
  fontSize: '0.73em',
  color: 'rgba(255,255,255,0.5)',
  margin: 0
};

// ============================================
// TEMPLATE CLASSIC
// ============================================
const MenuCellClassic = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Classic
  const {
    title = 'La Carte',
    subtitle,
    primaryColor = '#6b2d3a',
    // Bordeaux
    secondaryColor = '#c9a66b',
    // Doré
    accentColor = '#8b7355',
    // Brun chaleureux
    backgroundColor,
    textColor = '#3d2c2c',
    fontFamily,
    titleFontSize = '3.5em',
    cardBorderRadius = '0',
    cardBackground = '#fff',
    priceColor = '#6b2d3a',
    buttonText = 'Découvrir',
    searchPlaceholder = 'Rechercher...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '200px',
    containerPadding = '3em',
    gridGap = '2.5em',
    showOrnaments = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 100);
      });
    }, 150);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#2d5a27',
      'B': '#5a7a2d',
      'C': '#b8860b',
      'D': '#cd853f',
      'E': '#8b4513'
    };
    return colors[score] || '#8b7355';
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...classicContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...classicTitleStyle,
    fontSize: titleFontSize,
    color: primaryColor
  };
  const dynamicOrnamentStyle = {
    ...classicOrnamentTopStyle,
    color: secondaryColor
  };
  const dynamicDividerLineStyle = {
    ...classicDividerLineStyle,
    background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
  };
  const dynamicSearchInputStyle = {
    ...classicSearchInputStyle,
    borderColor: secondaryColor
  };
  const dynamicProductsGridStyle = {
    ...classicProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} délice${filteredProducts.length > 1 ? 's' : ''} à découvrir`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: classicKeyframesCSS
    }), showOrnaments && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: dynamicOrnamentStyle,
      children: "\u2767 \u2767 \u2767"
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: classicHeaderStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: dynamicTitleStyle,
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicDividerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: dynamicDividerLineStyle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...classicDividerIconStyle,
            color: secondaryColor
          },
          children: "\u2726"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: dynamicDividerLineStyle
        })]
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...classicSubtitleStyle,
          color: accentColor
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: classicSearchContainerStyle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchInputStyle
        })
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: classicCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ClassicCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "Tout"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ClassicCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 60,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "classic-products-scroll",
      style: classicProductsScrollContainerStyle,
      children: [filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...classicEmptyIconStyle,
            color: secondaryColor
          },
          children: "\u2619"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...classicEmptyTitleStyle,
            color: primaryColor
          },
          children: "Aucun mets trouv\xE9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...classicEmptyTextStyle,
            color: accentColor
          },
          children: searchQuery ? "Veuillez modifier votre recherche" : "Cette section est actuellement vide"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ClassicProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients
          }
        }, product.id))
      }), showOrnaments && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...classicOrnamentBottomStyle,
          color: secondaryColor
        },
        children: "\u2766"
      })]
    })]
  });
};

// Composant bouton de catégorie Classic
const ClassicCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#6b2d3a',
  secondaryColor = '#c9a66b'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    style: {
      ...classicCategoryTabStyle,
      background: isActive ? primaryColor : 'transparent',
      color: isActive ? '#f5e6d3' : primaryColor,
      borderColor: isActive ? primaryColor : secondaryColor,
      transform: mounted ? 'translateY(0)' : 'translateY(8px)',
      opacity: mounted ? 1 : 0
    },
    children: children
  });
};

// Composant carte produit Classic
const ClassicProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#6b2d3a',
    secondaryColor = '#c9a66b',
    accentColor = '#8b7355',
    cardBackground = '#fff',
    cardBorderRadius = '0',
    imageHeight = '200px',
    priceColor = '#6b2d3a',
    buttonText = 'Découvrir',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true
  } = styles_properties;

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 2000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...classicProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius
  };
  const dynamicImageContainerStyle = {
    ...classicProductImageContainerStyle,
    height: imageHeight
  };
  const dynamicBorderStyle = {
    height: '4px',
    background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'translateY(-8px)' : 'translateY(0)' : 'translateY(30px)',
      opacity: isVisible ? 1 : 0,
      boxShadow: isHovered ? `0 20px 40px ${primaryColor}26, 0 0 0 2px ${secondaryColor}` : '0 4px 20px rgba(139, 115, 85, 0.1)'
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: dynamicBorderStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: uri_transformer(currentImage),
        alt: product.name,
        style: {
          ...classicProductImageStyle,
          transform: isHovered ? 'scale(1.05)' : 'scale(1)'
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: classicImagePlaceholderStyle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.33em',
            color: secondaryColor
          },
          children: "\u2619"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: classicImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...classicImageIndicatorStyle,
            background: i === currentImageIndex ? primaryColor : secondaryColor
          }
        }, i))
      }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...classicHighlightBadgeStyle,
          background: primaryColor
        },
        children: "\u2605 Coup de c\u0153ur"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: classicProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: classicProductNameStyle,
        children: product.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...classicProductDividerStyle,
          background: secondaryColor
        }
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...classicProductDescriptionStyle,
          color: accentColor
        },
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...classicTagStyle,
            color: primaryColor
          },
          children: tag
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: classicAllergenTagStyle,
          title: allergen.description || '',
          children: allergen.name || allergen
        }, `allergen-${i}`))]
      }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicNutriScoreStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            marginRight: '0.5em',
            fontSize: '0.5em',
            color: accentColor
          },
          children: "Nutri-Score"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...classicNutriScoreBadgeStyle,
            background: getNutriScoreColor(product.nutrition_score)
          },
          children: product.nutrition_score
        })]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        style: classicIngredientsStyle,
        children: [product.ingredients.slice(0, 3).join(', '), product.ingredients.length > 3 && '...']
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicPriceRowStyle,
        children: [showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...classicPriceStyle,
            color: priceColor
          },
          children: formatPrice(price)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          style: {
            ...classicActionButtonStyle,
            background: isHovered ? primaryColor : 'transparent',
            color: isHovered ? '#f5e6d3' : primaryColor,
            borderColor: primaryColor
          },
          children: buttonText
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: dynamicBorderStyle
    })]
  });
};

// Keyframes CSS pour le template Classic
const classicKeyframesCSS = `
    @keyframes classicFadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }
    @keyframes classicFloat {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-3px); }
    }
    @keyframes classicShine {
        0% { background-position: -200% center; }
        100% { background-position: 200% center; }
    }
    
    /* Classic Scrollbar styling */
    .classic-products-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .classic-products-scroll::-webkit-scrollbar-track {
        background: rgba(201, 166, 107, 0.1);
        border-radius: 4px;
    }
    .classic-products-scroll::-webkit-scrollbar-thumb {
        background: rgba(201, 166, 107, 0.4);
        border-radius: 4px;
    }
    .classic-products-scroll::-webkit-scrollbar-thumb:hover {
        background: rgba(201, 166, 107, 0.6);
    }
`;

// Styles Classic
const classicContainerStyle = {
  fontFamily: "'Playfair Display', 'Cormorant Garamond', 'Libre Baskerville', Georgia, serif",
  background: 'linear-gradient(180deg, #f5e6d3 0%, #faf6f0 30%, #f5e6d3 100%)',
  color: '#3d2c2c',
  height: '100%',
  padding: '3em',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column'
};
const classicProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em'
};
const classicOrnamentTopStyle = {
  textAlign: 'center',
  fontSize: '0.67em',
  color: '#c9a66b',
  marginBottom: '1em',
  letterSpacing: '1em'
};
const classicOrnamentBottomStyle = {
  textAlign: 'center',
  fontSize: '1.33em',
  color: '#c9a66b',
  marginTop: '3em',
  paddingBottom: '1em'
};
const classicHeaderStyle = {
  textAlign: 'center',
  marginBottom: '2.5em'
};
const classicTitleStyle = {
  fontSize: '2.33em',
  fontWeight: '400',
  fontStyle: 'italic',
  margin: '0 0 1em',
  color: '#6b2d3a',
  letterSpacing: '0.1em',
  textShadow: '2px 2px 4px rgba(139, 115, 85, 0.1)'
};
const classicDividerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1em',
  marginBottom: '1em'
};
const classicDividerLineStyle = {
  width: '80px',
  height: '1px',
  background: 'linear-gradient(90deg, transparent, #c9a66b, transparent)'
};
const classicDividerIconStyle = {
  color: '#c9a66b',
  fontSize: '0.53em'
};
const classicSubtitleStyle = {
  fontSize: '0.73em',
  color: '#8b7355',
  margin: 0,
  fontWeight: '300',
  fontStyle: 'italic'
};
const classicSearchContainerStyle = {
  maxWidth: '350px',
  margin: '1.5em auto 0'
};
const classicSearchInputStyle = {
  width: '100%',
  padding: '0.9em 1.5em',
  fontSize: '0.63em',
  color: '#3d2c2c',
  background: '#fff',
  border: '1px solid #c9a66b',
  borderRadius: '0',
  outline: 'none',
  boxSizing: 'border-box',
  textAlign: 'center',
  fontFamily: 'inherit',
  fontStyle: 'italic',
  transition: 'all 0.3s ease'
};
const classicCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  overflowX: 'auto',
  marginBottom: '2.5em',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const classicCategoryTabStyle = {
  padding: '0.7em 1.8em',
  fontSize: '0.6em',
  fontWeight: '400',
  fontFamily: 'inherit',
  border: '1px solid',
  borderRadius: '0',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const classicProductsGridStyle = {
  display: 'grid',
  gap: '2.5em'
};
const classicProductCardStyle = {
  background: '#fff',
  overflow: 'hidden',
  border: '1px solid #e8dcc8',
  transition: 'all 0.4s ease',
  cursor: 'pointer',
  position: 'relative'
};
const classicCardBorderTopStyle = {
  height: '4px',
  background: 'linear-gradient(90deg, transparent, #c9a66b, transparent)'
};
const classicCardBorderBottomStyle = {
  height: '4px',
  background: 'linear-gradient(90deg, transparent, #c9a66b, transparent)'
};
const classicProductImageContainerStyle = {
  position: 'relative',
  height: '200px',
  background: '#f5e6d3',
  overflow: 'hidden'
};
const classicProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.5s ease'
};
const classicImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};
const classicImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '0.75em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px'
};
const classicImageIndicatorStyle = {
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  transition: 'all 0.3s ease'
};
const classicHighlightBadgeStyle = {
  position: 'absolute',
  top: '0.75em',
  left: '0.75em',
  padding: '0.4em 0.9em',
  fontSize: '0.47em',
  fontWeight: '400',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: '#f5e6d3',
  background: '#6b2d3a',
  fontStyle: 'italic'
};
const classicProductContentStyle = {
  padding: '1.5em',
  textAlign: 'center'
};
const classicProductNameStyle = {
  fontSize: '0.93em',
  fontWeight: '400',
  fontStyle: 'italic',
  margin: '0 0 0.75em',
  color: '#3d2c2c',
  letterSpacing: '0.03em'
};
const classicProductDividerStyle = {
  width: '50px',
  height: '1px',
  background: '#c9a66b',
  margin: '0 auto 1em'
};
const classicProductDescriptionStyle = {
  fontSize: '0.6em',
  color: '#8b7355',
  margin: '0 0 1em',
  lineHeight: 1.7,
  fontStyle: 'italic'
};
const classicTagsContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '0.75em'
};
const classicTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.47em',
  color: '#6b2d3a',
  background: 'transparent',
  border: '1px solid #d4c4b0',
  textTransform: 'uppercase',
  letterSpacing: '0.05em'
};
const classicAllergenTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.47em',
  color: '#8b4513',
  background: 'rgba(139, 69, 19, 0.08)',
  border: '1px solid rgba(139, 69, 19, 0.2)',
  textTransform: 'uppercase',
  letterSpacing: '0.05em'
};
const classicNutriScoreStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '0.75em'
};
const classicNutriScoreBadgeStyle = {
  padding: '0.2em 0.5em',
  fontSize: '0.5em',
  fontWeight: '600',
  color: '#fff',
  borderRadius: '2px'
};
const classicIngredientsStyle = {
  fontSize: '0.53em',
  color: '#a89880',
  margin: '0 0 1em',
  fontStyle: 'italic'
};
const classicPriceRowStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1em',
  paddingTop: '1em',
  borderTop: '1px solid #e8dcc8',
  marginTop: '0.5em'
};
const classicPriceStyle = {
  fontSize: '0.93em',
  fontWeight: '400',
  color: '#6b2d3a',
  fontStyle: 'italic'
};
const classicActionButtonStyle = {
  padding: '0.6em 1.2em',
  fontSize: '0.53em',
  fontWeight: '400',
  fontFamily: 'inherit',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  border: '1px solid #6b2d3a',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const classicEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center'
};
const classicEmptyIconStyle = {
  fontSize: '2.67em',
  marginBottom: '1.5em',
  color: '#c9a66b'
};
const classicEmptyTitleStyle = {
  fontSize: '0.53em',
  fontWeight: '400',
  fontStyle: 'italic',
  margin: '0 0 0.75em',
  color: '#6b2d3a'
};
const classicEmptyTextStyle = {
  fontSize: '0.67em',
  color: '#8b7355',
  margin: 0,
  fontStyle: 'italic'
};

// ============================================
// TEMPLATE MODERNE (Futuriste/Cyberpunk)
// ============================================
const MenuCellModerne = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const [scanEffect, setScanEffect] = (0, _react.useState)(false);
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Moderne
  const {
    title = 'MENU',
    subtitle,
    primaryColor = '#00f0ff',
    // Cyan néon
    secondaryColor = '#ff00ff',
    // Magenta néon
    accentColor = '#00ff88',
    // Vert néon
    backgroundColor,
    textColor = '#ffffff',
    fontFamily,
    titleFontSize = '4em',
    cardBorderRadius = '0',
    cardBackground = 'rgba(10, 10, 30, 0.8)',
    priceColor = '#00ff88',
    buttonText = 'SCANNER →',
    searchPlaceholder = '// RECHERCHE...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '180px',
    containerPadding = '2em',
    gridGap = '1.5em',
    showScanLines = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive avec effet de scan
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    setScanEffect(true);
    const timer = setTimeout(() => {
      setScanEffect(false);
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 60);
      });
    }, 300);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#00ff88',
      'B': '#88ff00',
      'C': '#ffff00',
      'D': '#ff8800',
      'E': '#ff0044'
    };
    return colors[score] || '#00f0ff';
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...moderneContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...moderneTitleStyle,
    fontSize: titleFontSize,
    color: primaryColor,
    textShadow: `0 0 30px ${primaryColor}, 0 0 60px ${primaryColor}50`
  };
  const dynamicSearchStyle = {
    ...moderneSearchInputStyle,
    borderColor: primaryColor,
    boxShadow: `0 0 10px ${primaryColor}40, inset 0 0 10px ${primaryColor}20`
  };
  const dynamicProductsGridStyle = {
    ...moderneProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `// ${filteredProducts.length} ITEM${filteredProducts.length > 1 ? 'S' : ''} DISPONIBLE${filteredProducts.length > 1 ? 'S' : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: moderneKeyframesCSS
    }), showScanLines && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: moderneScanLinesStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: moderneGridBackgroundStyle
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: moderneHeaderStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneHeaderTopStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneCornerStyle,
            color: secondaryColor
          },
          children: "\u25E2"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: dynamicTitleStyle,
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneCornerStyle,
            color: secondaryColor
          },
          children: "\u25E3"
        })]
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...moderneSubtitleStyle,
          color: accentColor
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneSearchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneSearchIconStyle,
            color: primaryColor
          },
          children: "\u2318"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchStyle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneSearchCursorStyle,
            background: primaryColor
          }
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: moderneCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ModerneCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "\u25C8 TOUS"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ModerneCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 40,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name.toUpperCase()
      }, category.id))]
    }), scanEffect && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneScanBarStyle,
        background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "moderne-products-scroll",
      style: moderneProductsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneEmptyIconStyle,
            color: primaryColor
          },
          children: "\u26A0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...moderneEmptyTitleStyle,
            color: primaryColor,
            textShadow: `0 0 20px ${primaryColor}`
          },
          children: "AUCUNE DONN\xC9E"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...moderneEmptyTextStyle,
            color: secondaryColor
          },
          children: searchQuery ? "// REQUÊTE NON TROUVÉE" : "// CATÉGORIE VIDE"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ModerneProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients
          }
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...moderneFooterStyle,
        borderColor: `${primaryColor}33`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor
        },
        children: "\u25E2\u25E4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        style: {
          color: primaryColor
        },
        children: [filteredProducts.length, "/", products.length, " ITEMS"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor
        },
        children: "\u25E5\u25E3"
      })]
    })]
  });
};

// Composant bouton de catégorie Moderne
const ModerneCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#00f0ff',
  secondaryColor = '#ff00ff'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [hovered, setHovered] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      ...moderneCategoryTabStyle,
      background: isActive ? `linear-gradient(135deg, ${primaryColor}33 0%, ${secondaryColor}33 100%)` : hovered ? `${primaryColor}11` : 'transparent',
      color: isActive ? primaryColor : hovered ? primaryColor : 'rgba(255,255,255,0.6)',
      borderColor: isActive ? primaryColor : hovered ? `${primaryColor}66` : 'rgba(255,255,255,0.1)',
      boxShadow: isActive ? `0 0 20px ${primaryColor}40, inset 0 0 20px ${primaryColor}20` : hovered ? `0 0 10px ${primaryColor}20` : 'none',
      transform: mounted ? isActive ? 'scale(1.05)' : 'scale(1)' : 'translateY(10px) scale(0.9)',
      opacity: mounted ? 1 : 0
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        ...moderneGlitchStyle,
        opacity: isActive ? 1 : 0
      },
      children: children
    }), children]
  });
};

// Composant carte produit Moderne
const ModerneProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [glitchEffect, setGlitchEffect] = (0, _react.useState)(false);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#00f0ff',
    secondaryColor = '#ff00ff',
    accentColor = '#00ff88',
    cardBackground = 'rgba(10, 10, 30, 0.8)',
    cardBorderRadius = '0',
    imageHeight = '180px',
    priceColor = '#00ff88',
    buttonText = 'SCANNER →',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true
  } = styles_properties;

  // Effet glitch au survol
  (0, _react.useEffect)(() => {
    if (isHovered) {
      setGlitchEffect(true);
      const timer = setTimeout(() => setGlitchEffect(false), 150);
      return () => clearTimeout(timer);
    }
  }, [isHovered]);

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 1200);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...moderneProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius,
    borderColor: isHovered ? primaryColor : 'rgba(255,255,255,0.1)',
    boxShadow: isHovered ? `0 0 30px ${primaryColor}40, 0 0 60px ${primaryColor}20, inset 0 0 30px ${primaryColor}10` : '0 0 20px rgba(0, 0, 0, 0.5)'
  };
  const dynamicImageContainerStyle = {
    ...moderneProductImageContainerStyle,
    height: imageHeight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'translateY(-5px) scale(1.02)' : 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)',
      opacity: isVisible ? 1 : 0,
      filter: glitchEffect ? 'hue-rotate(90deg)' : 'none'
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneCornerDecorStyle,
        top: 0,
        left: 0,
        borderTopColor: primaryColor,
        borderLeftColor: primaryColor
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneCornerDecorStyle,
        top: 0,
        right: 0,
        borderTopColor: primaryColor,
        borderRightColor: primaryColor
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneCornerDecorStyle,
        bottom: 0,
        left: 0,
        borderBottomColor: primaryColor,
        borderLeftColor: primaryColor
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneCornerDecorStyle,
        bottom: 0,
        right: 0,
        borderBottomColor: primaryColor,
        borderRightColor: primaryColor
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...moderneProductIdStyle,
        color: secondaryColor
      },
      children: ["#", String(index + 1).padStart(3, '0')]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...moderneProductImageStyle,
            transform: isHovered ? 'scale(1.1)' : 'scale(1)',
            filter: isHovered ? 'brightness(1.2) contrast(1.1)' : 'brightness(0.9)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneHoloOverlayStyle,
            background: `linear-gradient(135deg, ${primaryColor}20 0%, transparent 50%, ${secondaryColor}20 100%)`,
            opacity: isHovered ? 1 : 0.3
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: moderneImageScanLinesStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneImagePlaceholderStyle,
          color: primaryColor
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.33em'
          },
          children: "\u25C7"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: moderneImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneImageIndicatorStyle,
            background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.3)',
            boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none'
          }
        }, i))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneBadgesContainerStyle,
        children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneBadgeStyle,
            background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
            boxShadow: `0 0 15px ${secondaryColor}`
          },
          children: "\u2605 HOT"
        }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...moderneBadgeStyle,
            background: getNutriScoreColor(product.nutrition_score),
            boxShadow: `0 0 10px ${getNutriScoreColor(product.nutrition_score)}`
          },
          children: product.nutrition_score
        })]
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneFloatingPriceStyle,
          background: 'rgba(0, 0, 0, 0.8)',
          borderColor: priceColor,
          color: priceColor,
          boxShadow: `0 0 15px ${priceColor}40`
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: moderneProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          ...moderneProductNameStyle,
          color: primaryColor
        },
        children: product.name?.toUpperCase()
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneDataLineStyle,
          background: `linear-gradient(90deg, ${primaryColor}66, transparent)`
        }
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: moderneProductDescriptionStyle,
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...moderneTagStyle,
            borderColor: `${primaryColor}66`,
            color: primaryColor
          },
          children: ["#", tag.toLowerCase().replace(/\s/g, '_')]
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...moderneAllergenTagStyle,
            borderColor: `${secondaryColor}66`,
            color: secondaryColor
          },
          title: allergen.description || '',
          children: ["\u26A0 ", (allergen.name || allergen).toUpperCase()]
        }, `allergen-${i}`))]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneIngredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: accentColor,
            marginRight: '0.5em'
          },
          children: "\u25B8"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: moderneIngredientsTextStyle,
          children: [product.ingredients.slice(0, 3).join(' · '), product.ingredients.length > 3 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        style: {
          ...moderneActionButtonStyle,
          borderColor: primaryColor,
          color: isHovered ? cardBackground : primaryColor,
          background: isHovered ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : 'transparent',
          boxShadow: isHovered ? `0 0 20px ${primaryColor}60` : 'none'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            marginRight: '0.5em'
          },
          children: '>'
        }), buttonText]
      })]
    }), isHovered && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...moderneShineEffectStyle,
        background: `linear-gradient(90deg, transparent, ${primaryColor}30, transparent)`
      }
    })]
  });
};

// Keyframes CSS pour le template Moderne
const moderneKeyframesCSS = `
    @keyframes modernePulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
    }
    @keyframes moderneScan {
        0% { top: 0; }
        100% { top: 100%; }
    }
    @keyframes moderneGlitch {
        0%, 100% { transform: translateX(0); }
        20% { transform: translateX(-2px); }
        40% { transform: translateX(2px); }
        60% { transform: translateX(-1px); }
        80% { transform: translateX(1px); }
    }
    @keyframes moderneFlicker {
        0%, 100% { opacity: 1; }
        92% { opacity: 1; }
        93% { opacity: 0.8; }
        94% { opacity: 1; }
        97% { opacity: 0.9; }
        98% { opacity: 1; }
    }
    @keyframes moderneBlink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
    }
    @keyframes moderneShimmer {
        0% { left: -100%; }
        100% { left: 200%; }
    }
    
    /* Moderne Scrollbar styling */
    .moderne-products-scroll::-webkit-scrollbar {
        width: 6px;
    }
    .moderne-products-scroll::-webkit-scrollbar-track {
        background: rgba(0, 240, 255, 0.05);
        border-radius: 0;
    }
    .moderne-products-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #00f0ff 0%, #ff00ff 100%);
        border-radius: 0;
    }
    .moderne-products-scroll::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, #00f0ff 0%, #ff00ff 100%);
        box-shadow: 0 0 10px #00f0ff;
    }
`;

// Styles Moderne
const moderneContainerStyle = {
  fontFamily: "'Orbitron', 'Rajdhani', 'Share Tech Mono', 'Courier New', monospace",
  background: 'linear-gradient(180deg, #0a0a1e 0%, #1a1a3e 50%, #0a0a1e 100%)',
  color: '#ffffff',
  height: '100%',
  padding: '2em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const moderneProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em',
  position: 'relative',
  zIndex: 2
};
const moderneScanLinesStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.1) 2px, rgba(0, 0, 0, 0.1) 4px)',
  pointerEvents: 'none',
  zIndex: 1
};
const moderneGridBackgroundStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `
        linear-gradient(rgba(0, 240, 255, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 240, 255, 0.03) 1px, transparent 1px)
    `,
  backgroundSize: '50px 50px',
  pointerEvents: 'none'
};
const moderneHeaderStyle = {
  position: 'relative',
  zIndex: 2,
  marginBottom: '2em',
  textAlign: 'center'
};
const moderneHeaderTopStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2em',
  marginBottom: '0.5em'
};
const moderneCornerStyle = {
  fontSize: '1.33em',
  animation: 'modernePulse 2s infinite'
};
const moderneTitleStyle = {
  fontSize: '2.67em',
  fontWeight: '700',
  margin: 0,
  letterSpacing: '0.5em',
  textTransform: 'uppercase',
  animation: 'moderneFlicker 3s infinite'
};
const moderneSubtitleStyle = {
  fontSize: '0.6em',
  margin: '0.5em 0 0',
  fontWeight: '300',
  letterSpacing: '0.3em',
  opacity: 0.8
};
const moderneSearchContainerStyle = {
  position: 'relative',
  maxWidth: '400px',
  margin: '1.5em auto 0',
  display: 'flex',
  alignItems: 'center'
};
const moderneSearchIconStyle = {
  position: 'absolute',
  left: '1em',
  fontSize: '0.67em',
  zIndex: 1
};
const moderneSearchInputStyle = {
  width: '100%',
  padding: '1em 1em 1em 3em',
  fontSize: '0.6em',
  color: '#fff',
  background: 'rgba(0, 0, 0, 0.5)',
  border: '1px solid',
  borderRadius: '0',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
};
const moderneSearchCursorStyle = {
  position: 'absolute',
  right: '1em',
  width: '2px',
  height: '1.2em',
  animation: 'moderneBlink 1s infinite'
};
const moderneCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  overflowX: 'auto',
  marginBottom: '2em',
  position: 'relative',
  zIndex: 2,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const moderneCategoryTabStyle = {
  padding: '0.7em 1.5em',
  fontSize: '0.53em',
  fontWeight: '500',
  fontFamily: 'inherit',
  border: '1px solid',
  borderRadius: '0',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textTransform: 'uppercase',
  letterSpacing: '0.15em',
  position: 'relative',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const moderneGlitchStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  animation: 'moderneGlitch 0.3s infinite',
  color: 'red',
  clipPath: 'inset(40% 0 40% 0)'
};
const moderneScanBarStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  height: '2px',
  animation: 'moderneScan 0.5s ease-out',
  zIndex: 10
};
const moderneProductsGridStyle = {
  display: 'grid',
  gap: '1.5em',
  position: 'relative',
  zIndex: 2
};
const moderneProductCardStyle = {
  background: 'rgba(10, 10, 30, 0.8)',
  overflow: 'hidden',
  border: '1px solid rgba(255,255,255,0.1)',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative',
  backdropFilter: 'blur(10px)'
};
const moderneCornerDecorStyle = {
  position: 'absolute',
  width: '15px',
  height: '15px',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 3
};
const moderneProductIdStyle = {
  position: 'absolute',
  top: '0.5em',
  right: '0.5em',
  fontSize: '0.47em',
  fontFamily: 'monospace',
  letterSpacing: '0.1em',
  zIndex: 3,
  opacity: 0.7
};
const moderneProductImageContainerStyle = {
  position: 'relative',
  height: '180px',
  background: '#000',
  overflow: 'hidden'
};
const moderneProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.5s ease'
};
const moderneHoloOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  transition: 'opacity 0.3s ease',
  pointerEvents: 'none'
};
const moderneImageScanLinesStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(0, 0, 0, 0.2) 1px, rgba(0, 0, 0, 0.2) 2px)',
  pointerEvents: 'none'
};
const moderneImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: 'linear-gradient(135deg, #0a0a1e 0%, #1a1a3e 100%)'
};
const moderneImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '0.5em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '6px',
  zIndex: 2
};
const moderneImageIndicatorStyle = {
  width: '20px',
  height: '3px',
  transition: 'all 0.3s ease'
};
const moderneBadgesContainerStyle = {
  position: 'absolute',
  top: '0.5em',
  left: '0.5em',
  display: 'flex',
  gap: '0.4em',
  flexWrap: 'wrap',
  zIndex: 2
};
const moderneBadgeStyle = {
  padding: '0.3em 0.6em',
  fontSize: '0.43em',
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: '#000'
};
const moderneFloatingPriceStyle = {
  position: 'absolute',
  bottom: '0.5em',
  right: '0.5em',
  padding: '0.4em 0.8em',
  fontSize: '0.67em',
  fontWeight: '700',
  border: '1px solid',
  fontFamily: 'monospace',
  zIndex: 2
};
const moderneProductContentStyle = {
  padding: '1em',
  position: 'relative'
};
const moderneProductNameStyle = {
  fontSize: '0.67em',
  fontWeight: '600',
  margin: '0 0 0.5em',
  letterSpacing: '0.1em'
};
const moderneDataLineStyle = {
  height: '1px',
  marginBottom: '0.75em'
};
const moderneProductDescriptionStyle = {
  fontSize: '0.53em',
  color: 'rgba(255,255,255,0.6)',
  margin: '0 0 0.75em',
  lineHeight: 1.5,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};
const moderneTagsContainerStyle = {
  display: 'flex',
  gap: '0.4em',
  flexWrap: 'wrap',
  marginBottom: '0.5em'
};
const moderneTagStyle = {
  padding: '0.2em 0.5em',
  fontSize: '0.43em',
  border: '1px solid',
  fontFamily: 'monospace'
};
const moderneAllergenTagStyle = {
  padding: '0.2em 0.5em',
  fontSize: '0.43em',
  border: '1px solid',
  fontFamily: 'monospace'
};
const moderneIngredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '0.75em'
};
const moderneIngredientsTextStyle = {
  fontSize: '0.47em',
  color: 'rgba(255,255,255,0.5)',
  fontStyle: 'normal'
};
const moderneActionButtonStyle = {
  width: '100%',
  padding: '0.7em',
  fontSize: '0.5em',
  fontWeight: '600',
  fontFamily: 'inherit',
  border: '1px solid',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textTransform: 'uppercase',
  letterSpacing: '0.2em'
};
const moderneShineEffectStyle = {
  position: 'absolute',
  top: 0,
  left: '-100%',
  width: '50%',
  height: '100%',
  animation: 'moderneShimmer 1s ease-out',
  pointerEvents: 'none'
};
const moderneEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center',
  position: 'relative',
  zIndex: 2
};
const moderneEmptyIconStyle = {
  fontSize: '2.67em',
  marginBottom: '1em',
  animation: 'modernePulse 1.5s infinite'
};
const moderneEmptyTitleStyle = {
  fontSize: '0.67em',
  fontWeight: '600',
  margin: '0 0 0.5em',
  letterSpacing: '0.3em',
  textTransform: 'uppercase'
};
const moderneEmptyTextStyle = {
  fontSize: '0.6em',
  margin: 0,
  letterSpacing: '0.2em'
};
const moderneFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2em',
  marginTop: '2em',
  padding: '1em 0',
  borderTop: '1px solid',
  fontSize: '0.53em',
  letterSpacing: '0.2em',
  position: 'relative',
  zIndex: 2
};

// ============================================
// TEMPLATE PRESTIGE (Royal/Luxueux)
// ============================================
const MenuCellPrestige = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Prestige
  const {
    title = 'La Maison',
    subtitle,
    primaryColor = '#d4af37',
    // Or
    secondaryColor = '#1a1a2e',
    // Noir profond
    accentColor = '#8b0000',
    // Bordeaux royal
    backgroundColor,
    textColor = '#f5f5dc',
    // Beige
    fontFamily,
    titleFontSize = '3.5em',
    cardBorderRadius = '0',
    cardBackground = 'linear-gradient(145deg, #1a1a2e 0%, #2d2d44 100%)',
    priceColor = '#d4af37',
    buttonText = 'Découvrir',
    searchPlaceholder = 'Rechercher une création...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '220px',
    containerPadding = '3em',
    gridGap = '2em',
    showCrown = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 120);
      });
    }, 200);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#228b22',
      'B': '#6b8e23',
      'C': '#daa520',
      'D': '#cd853f',
      'E': '#8b0000'
    };
    return colors[score] || primaryColor;
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...prestigeContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...prestigeTitleStyle,
    fontSize: titleFontSize,
    color: primaryColor
  };
  const dynamicSearchStyle = {
    ...prestigeSearchInputStyle,
    borderColor: `${primaryColor}66`
  };
  const dynamicProductsGridStyle = {
    ...prestigeProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} création${filteredProducts.length > 1 ? 's' : ''} d'exception`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: prestigeKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: prestigeVelvetOverlayStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: prestigePatternStyle
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: prestigeHeaderStyle,
      children: [showCrown && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeCrownStyle,
          color: primaryColor
        },
        children: "\u265B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeOrnamentStyle,
          color: primaryColor
        },
        children: "\u2500\u2500\u2500\u2500\u2500\u2500\u2500 \u2767 \u2500\u2500\u2500\u2500\u2500\u2500\u2500"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: dynamicTitleStyle,
        children: title
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...prestigeSubtitleStyle,
          color: `${textColor}99`
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeOrnamentStyle,
          color: primaryColor
        },
        children: "\u2500\u2500\u2500\u2500\u2500\u2500\u2500 \u2767 \u2500\u2500\u2500\u2500\u2500\u2500\u2500"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeSearchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...prestigeSearchIconStyle,
            color: primaryColor
          },
          children: "\u269C"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchStyle
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: prestigeCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PrestigeCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "\u269C Toutes"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PrestigeCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 50,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "prestige-products-scroll",
      style: prestigeProductsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...prestigeEmptyIconStyle,
            color: primaryColor
          },
          children: "\u265B"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...prestigeEmptyTitleStyle,
            color: primaryColor
          },
          children: "Aucune Cr\xE9ation"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...prestigeEmptyTextStyle,
            color: `${textColor}77`
          },
          children: searchQuery ? "Veuillez affiner votre recherche" : "Cette collection est actuellement vide"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PrestigeProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients,
            textColor
          }
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...prestigeFooterStyle,
        borderColor: `${primaryColor}33`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: primaryColor
        },
        children: "\u269C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: `${textColor}77`,
          letterSpacing: '0.3em',
          fontSize: '0.5em'
        },
        children: "EXCELLENCE & TRADITION"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: primaryColor
        },
        children: "\u269C"
      })]
    })]
  });
};

// Composant bouton de catégorie Prestige
const PrestigeCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#d4af37',
  secondaryColor = '#1a1a2e'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [hovered, setHovered] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      ...prestigeCategoryTabStyle,
      background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}cc 100%)` : hovered ? `${primaryColor}11` : 'transparent',
      color: isActive ? secondaryColor : hovered ? primaryColor : '#f5f5dc99',
      borderColor: isActive ? primaryColor : hovered ? primaryColor : `${primaryColor}44`,
      boxShadow: isActive ? `0 4px 20px ${primaryColor}40` : 'none',
      transform: mounted ? isActive ? 'scale(1.02)' : 'scale(1)' : 'translateY(10px)',
      opacity: mounted ? 1 : 0
    },
    children: children
  });
};

// Composant carte produit Prestige
const PrestigeProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#d4af37',
    secondaryColor = '#1a1a2e',
    accentColor = '#8b0000',
    cardBackground = 'linear-gradient(145deg, #1a1a2e 0%, #2d2d44 100%)',
    cardBorderRadius = '0',
    imageHeight = '220px',
    priceColor = '#d4af37',
    buttonText = 'Découvrir',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    textColor = '#f5f5dc'
  } = styles_properties;

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 2500);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...prestigeProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius,
    borderColor: isHovered ? primaryColor : `${primaryColor}33`,
    boxShadow: isHovered ? `0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px ${primaryColor}20, inset 0 1px 0 ${primaryColor}22` : `0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 ${primaryColor}11`
  };
  const dynamicImageContainerStyle = {
    ...prestigeProductImageContainerStyle,
    height: imageHeight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'translateY(-8px)' : 'translateY(0)' : 'translateY(40px)',
      opacity: isVisible ? 1 : 0
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...prestigeFrameStyle,
        top: 0,
        borderTopColor: primaryColor,
        background: `linear-gradient(90deg, transparent, ${primaryColor}33, transparent)`
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...prestigeProductImageStyle,
            transform: isHovered ? 'scale(1.08)' : 'scale(1)',
            filter: isHovered ? 'brightness(1.1)' : 'brightness(0.95)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: prestigeImageVignetteStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeImagePlaceholderStyle,
          color: primaryColor
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.33em'
          },
          children: "\u269C"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: prestigeImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...prestigeImageIndicatorStyle,
            background: i === currentImageIndex ? primaryColor : `${primaryColor}44`,
            transform: i === currentImageIndex ? 'rotate(45deg) scale(1.3)' : 'rotate(45deg)',
            boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none'
          }
        }, i))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeBadgesContainerStyle,
        children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...prestigeBadgeStyle,
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${accentColor} 100%)`,
            color: '#fff'
          },
          children: "\u2605 Signature"
        }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...prestigeBadgeStyle,
            background: getNutriScoreColor(product.nutrition_score),
            color: '#fff'
          },
          children: product.nutrition_score
        })]
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...prestigeFloatingPriceStyle,
          background: secondaryColor,
          borderColor: primaryColor,
          color: primaryColor
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.47em',
            opacity: 0.7
          },
          children: "\u2726"
        }), formatPrice(price), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.47em',
            opacity: 0.7
          },
          children: "\u2726"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: prestigeProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeFleurDeLysStyle,
          color: primaryColor
        },
        children: "\u269C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          ...prestigeProductNameStyle,
          color: textColor
        },
        children: product.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeProductDividerStyle,
          background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
        }
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...prestigeProductDescriptionStyle,
          color: `${textColor}88`
        },
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...prestigeTagStyle,
            borderColor: `${primaryColor}44`,
            color: primaryColor
          },
          children: tag
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...prestigeAllergenTagStyle,
            borderColor: `${accentColor}44`,
            color: accentColor
          },
          title: allergen.description || '',
          children: allergen.name || allergen
        }, `allergen-${i}`))]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeIngredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor,
            marginRight: '0.5em',
            fontSize: '0.53em'
          },
          children: "\u2767"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...prestigeIngredientsTextStyle,
            color: `${textColor}66`
          },
          children: [product.ingredients.slice(0, 3).join(' • '), product.ingredients.length > 3 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...prestigeActionButtonStyle,
          borderColor: primaryColor,
          color: isHovered ? secondaryColor : primaryColor,
          background: isHovered ? `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)` : 'transparent',
          boxShadow: isHovered ? `0 4px 20px ${primaryColor}40` : 'none'
        },
        children: buttonText
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...prestigeFrameStyle,
        bottom: 0,
        borderBottomColor: primaryColor,
        background: `linear-gradient(90deg, transparent, ${primaryColor}33, transparent)`
      }
    })]
  });
};

// Keyframes CSS pour le template Prestige
const prestigeKeyframesCSS = `
    @keyframes prestigeShine {
        0% { background-position: -200% center; }
        100% { background-position: 200% center; }
    }
    @keyframes prestigeFloat {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-3px); }
    }
    @keyframes prestigeGlow {
        0%, 100% { opacity: 0.5; }
        50% { opacity: 1; }
    }
    @keyframes prestigeFadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    /* Prestige Scrollbar styling */
    .prestige-products-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .prestige-products-scroll::-webkit-scrollbar-track {
        background: rgba(212, 175, 55, 0.05);
        border-radius: 0;
    }
    .prestige-products-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #d4af37 0%, #8b0000 100%);
        border-radius: 0;
    }
    .prestige-products-scroll::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, #d4af37 0%, #a00000 100%);
    }
`;

// Styles Prestige
const prestigeContainerStyle = {
  fontFamily: "'Cormorant Garamond', 'Playfair Display', 'Libre Baskerville', 'Times New Roman', serif",
  background: 'linear-gradient(180deg, #0d0d1a 0%, #1a1a2e 30%, #0d0d1a 100%)',
  color: '#f5f5dc',
  height: '100%',
  padding: '3em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const prestigeProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em',
  position: 'relative',
  zIndex: 2
};
const prestigeVelvetOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0, 0, 0, 0.4) 100%)',
  pointerEvents: 'none'
};
const prestigePatternStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4af37' fill-opacity='0.03'%3E%3Cpath d='M30 30l15-15v30l-15 15-15-15V15l15 15z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
  pointerEvents: 'none'
};
const prestigeHeaderStyle = {
  position: 'relative',
  zIndex: 2,
  marginBottom: '3em',
  textAlign: 'center'
};
const prestigeCrownStyle = {
  fontSize: '1.33em',
  marginBottom: '0.5em',
  animation: 'prestigeFloat 3s ease-in-out infinite'
};
const prestigeOrnamentStyle = {
  fontSize: '0.67em',
  letterSpacing: '0.5em',
  marginBottom: '0.5em',
  opacity: 0.7
};
const prestigeTitleStyle = {
  fontSize: '2.33em',
  fontWeight: '400',
  margin: '0.5em 0',
  letterSpacing: '0.2em',
  textTransform: 'uppercase',
  fontStyle: 'normal'
};
const prestigeSubtitleStyle = {
  fontSize: '0.73em',
  margin: '1em 0 0',
  fontWeight: '300',
  fontStyle: 'italic',
  letterSpacing: '0.1em'
};
const prestigeSearchContainerStyle = {
  position: 'relative',
  maxWidth: '400px',
  margin: '2em auto 0'
};
const prestigeSearchIconStyle = {
  position: 'absolute',
  left: '1.2em',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '0.67em',
  zIndex: 1
};
const prestigeSearchInputStyle = {
  width: '100%',
  padding: '1em 1em 1em 3.5em',
  fontSize: '0.63em',
  color: '#f5f5dc',
  background: 'rgba(0, 0, 0, 0.3)',
  border: '1px solid',
  borderRadius: '0',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  fontStyle: 'italic',
  letterSpacing: '0.05em',
  transition: 'all 0.3s ease'
};
const prestigeCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.75em',
  overflowX: 'auto',
  marginBottom: '3em',
  position: 'relative',
  zIndex: 2,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const prestigeCategoryTabStyle = {
  padding: '0.8em 2em',
  fontSize: '0.57em',
  fontWeight: '400',
  fontFamily: 'inherit',
  border: '1px solid',
  borderRadius: '0',
  cursor: 'pointer',
  transition: 'all 0.4s ease',
  letterSpacing: '0.15em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const prestigeProductsGridStyle = {
  display: 'grid',
  gap: '2em',
  position: 'relative',
  zIndex: 2
};
const prestigeProductCardStyle = {
  overflow: 'hidden',
  border: '1px solid',
  transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative'
};
const prestigeFrameStyle = {
  position: 'absolute',
  left: '10%',
  right: '10%',
  height: '2px',
  zIndex: 3
};
const prestigeProductImageContainerStyle = {
  position: 'relative',
  height: '220px',
  overflow: 'hidden',
  background: '#0a0a14'
};
const prestigeProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.6s ease'
};
const prestigeImageVignetteStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  boxShadow: 'inset 0 0 50px rgba(0, 0, 0, 0.5)',
  pointerEvents: 'none'
};
const prestigeImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: 'linear-gradient(135deg, #0a0a14 0%, #1a1a2e 100%)'
};
const prestigeImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '1em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 2
};
const prestigeImageIndicatorStyle = {
  width: '8px',
  height: '8px',
  transition: 'all 0.3s ease'
};
const prestigeBadgesContainerStyle = {
  position: 'absolute',
  top: '1em',
  left: '1em',
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap',
  zIndex: 2
};
const prestigeBadgeStyle = {
  padding: '0.35em 0.75em',
  fontSize: '0.43em',
  fontWeight: '500',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  fontStyle: 'italic'
};
const prestigeFloatingPriceStyle = {
  position: 'absolute',
  bottom: '1em',
  right: '1em',
  padding: '0.5em 1em',
  fontSize: '0.73em',
  fontWeight: '400',
  border: '1px solid',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
  zIndex: 2,
  fontStyle: 'italic'
};
const prestigeProductContentStyle = {
  padding: '1.5em',
  position: 'relative',
  textAlign: 'center'
};
const prestigeFleurDeLysStyle = {
  fontSize: '0.53em',
  marginBottom: '0.5em',
  opacity: 0.6
};
const prestigeProductNameStyle = {
  fontSize: '0.87em',
  fontWeight: '500',
  margin: '0 0 0.75em',
  letterSpacing: '0.05em'
};
const prestigeProductDividerStyle = {
  width: '60px',
  height: '1px',
  margin: '0 auto 1em'
};
const prestigeProductDescriptionStyle = {
  fontSize: '0.6em',
  margin: '0 0 1em',
  lineHeight: 1.7,
  fontStyle: 'italic',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};
const prestigeTagsContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '0.75em'
};
const prestigeTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.47em',
  border: '1px solid',
  fontStyle: 'italic'
};
const prestigeAllergenTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.47em',
  border: '1px solid',
  fontStyle: 'italic'
};
const prestigeIngredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1em'
};
const prestigeIngredientsTextStyle = {
  fontSize: '0.53em',
  fontStyle: 'italic'
};
const prestigeActionButtonStyle = {
  width: '100%',
  padding: '0.85em',
  fontSize: '0.57em',
  fontWeight: '400',
  fontFamily: 'inherit',
  border: '1px solid',
  cursor: 'pointer',
  transition: 'all 0.4s ease',
  letterSpacing: '0.2em',
  textTransform: 'uppercase'
};
const prestigeEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center',
  position: 'relative',
  zIndex: 2
};
const prestigeEmptyIconStyle = {
  fontSize: '2.67em',
  marginBottom: '1.5em',
  animation: 'prestigeFloat 3s ease-in-out infinite'
};
const prestigeEmptyTitleStyle = {
  fontSize: '0.53em',
  fontWeight: '400',
  margin: '0 0 0.75em',
  letterSpacing: '0.1em',
  fontStyle: 'italic'
};
const prestigeEmptyTextStyle = {
  fontSize: '0.67em',
  margin: 0,
  fontStyle: 'italic'
};
const prestigeFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2em',
  marginTop: '3em',
  padding: '1.5em 0',
  borderTop: '1px solid',
  position: 'relative',
  zIndex: 2
};

// ============================================
// TEMPLATE STREET (Urban/Street Food)
// ============================================
const MenuCellStreet = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Street
  const {
    title = 'STREET FOOD',
    subtitle,
    primaryColor = '#ffcc00',
    // Jaune vif
    secondaryColor = '#ff3333',
    // Rouge vif
    accentColor = '#00cc66',
    // Vert
    backgroundColor,
    textColor = '#ffffff',
    fontFamily,
    titleFontSize = '4em',
    cardBorderRadius = '0',
    cardBackground = 'rgba(30, 30, 30, 0.95)',
    priceColor = '#ffcc00',
    buttonText = 'JE VEUX ÇA!',
    searchPlaceholder = 'Cherche ton kiff...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '200px',
    containerPadding = '2em',
    gridGap = '1.5em',
    showGraffiti = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 80);
      });
    }, 100);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#00cc66',
      'B': '#99cc00',
      'C': '#ffcc00',
      'D': '#ff9933',
      'E': '#ff3333'
    };
    return colors[score] || primaryColor;
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...streetContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...streetTitleStyle,
    fontSize: titleFontSize,
    color: primaryColor,
    textShadow: `4px 4px 0 ${secondaryColor}, 8px 8px 0 rgba(0,0,0,0.3)`
  };
  const dynamicSearchStyle = {
    ...streetSearchInputStyle,
    borderColor: primaryColor
  };
  const dynamicProductsGridStyle = {
    ...streetProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} TRUCS DE OUF`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: streetKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: streetConcreteTextureStyle
    }), showGraffiti && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetGraffitiStyle,
          top: '10%',
          left: '5%',
          transform: 'rotate(-15deg)',
          color: secondaryColor
        },
        children: "\u2605"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetGraffitiStyle,
          top: '20%',
          right: '8%',
          transform: 'rotate(10deg)',
          color: accentColor
        },
        children: "\u2726"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetGraffitiStyle,
          bottom: '15%',
          left: '10%',
          transform: 'rotate(5deg)',
          color: primaryColor
        },
        children: "\u25C6"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetSplatStyle,
          top: '5%',
          right: '15%',
          background: `${secondaryColor}22`
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetSplatStyle,
          bottom: '10%',
          left: '20%',
          background: `${primaryColor}22`
        }
      })]
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: streetHeaderStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetTitleContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...streetTagStyle,
            background: secondaryColor
          },
          children: "HOT"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: dynamicTitleStyle,
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...streetTagStyle,
            background: accentColor
          },
          children: "FRESH"
        })]
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...streetSubtitleStyle,
          color: `${textColor}aa`
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetSearchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...streetSearchIconStyle,
            color: primaryColor
          },
          children: "\uD83D\uDD25"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchStyle
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: streetCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StreetCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "\uD83C\uDF54 TOUT"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(StreetCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 50,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name.toUpperCase()
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "street-products-scroll",
      style: streetProductsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...streetEmptyIconStyle,
            color: primaryColor
          },
          children: "\uD83D\uDEAB"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...streetEmptyTitleStyle,
            color: primaryColor
          },
          children: "NADA!"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...streetEmptyTextStyle,
            color: secondaryColor
          },
          children: searchQuery ? "Rien trouvé, essaie autre chose!" : "Cette catégorie est vide, bro"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(StreetProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients,
            textColor
          }
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...streetFooterStyle,
        borderColor: `${primaryColor}66`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor,
          fontSize: '0.67em'
        },
        children: "\uD83D\uDD25"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: primaryColor,
          fontWeight: '900',
          letterSpacing: '0.2em'
        },
        children: "MADE WITH \u2764\uFE0F ON THE STREETS"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor,
          fontSize: '0.67em'
        },
        children: "\uD83D\uDD25"
      })]
    })]
  });
};

// Composant bouton de catégorie Street
const StreetCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#ffcc00',
  secondaryColor = '#ff3333'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [hovered, setHovered] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // Rotation aléatoire légère pour effet sticker
  const rotation = (0, _react.useMemo)(() => (Math.random() - 0.5) * 6, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      ...streetCategoryTabStyle,
      background: isActive ? primaryColor : hovered ? `${primaryColor}33` : '#1a1a1a',
      color: isActive ? '#000' : hovered ? primaryColor : '#fff',
      borderColor: isActive ? primaryColor : hovered ? primaryColor : '#333',
      transform: mounted ? `rotate(${isActive ? 0 : rotation}deg) scale(${hovered ? 1.05 : 1})` : 'translateY(20px) scale(0.8)',
      opacity: mounted ? 1 : 0,
      boxShadow: isActive ? `4px 4px 0 ${secondaryColor}` : hovered ? `2px 2px 0 ${primaryColor}` : 'none'
    },
    children: children
  });
};

// Composant carte produit Street
const StreetProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#ffcc00',
    secondaryColor = '#ff3333',
    accentColor = '#00cc66',
    cardBackground = 'rgba(30, 30, 30, 0.95)',
    cardBorderRadius = '0',
    imageHeight = '200px',
    priceColor = '#ffcc00',
    buttonText = 'JE VEUX ÇA!',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    textColor = '#ffffff'
  } = styles_properties;

  // Rotation aléatoire légère pour effet naturel
  const rotation = (0, _react.useMemo)(() => (Math.random() - 0.5) * 2, []);

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 1500);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...streetProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius,
    borderColor: isHovered ? primaryColor : '#333',
    boxShadow: isHovered ? `8px 8px 0 ${secondaryColor}, 0 0 30px ${primaryColor}40` : `4px 4px 0 #000`
  };
  const dynamicImageContainerStyle = {
    ...streetProductImageContainerStyle,
    height: imageHeight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'rotate(0deg) scale(1.02)' : `rotate(${rotation}deg) scale(1)` : 'translateY(50px) rotate(10deg) scale(0.8)',
      opacity: isVisible ? 1 : 0
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...streetStickerStyle,
        background: secondaryColor
      },
      children: "\uD83D\uDD25 HOT!"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...streetProductImageStyle,
            transform: isHovered ? 'scale(1.1)' : 'scale(1)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: streetImageOverlayStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetImagePlaceholderStyle,
          color: primaryColor
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '2.67em'
          },
          children: "\uD83C\uDF54"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: streetImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...streetImageIndicatorStyle,
            background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.4)',
            boxShadow: i === currentImageIndex ? `0 0 8px ${primaryColor}` : 'none'
          }
        }, i))
      }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          ...streetNutriBadgeStyle,
          background: getNutriScoreColor(product.nutrition_score)
        },
        children: product.nutrition_score
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetFloatingPriceStyle,
          background: priceColor,
          color: '#000',
          boxShadow: `3px 3px 0 ${secondaryColor}`
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: streetProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          ...streetProductNameStyle,
          color: textColor
        },
        children: product.name?.toUpperCase()
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...streetProductDescriptionStyle,
          color: `${textColor}99`
        },
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...streetProductTagStyle,
            background: i % 2 === 0 ? `${primaryColor}33` : `${accentColor}33`,
            color: i % 2 === 0 ? primaryColor : accentColor
          },
          children: ["#", tag.toLowerCase().replace(/\s/g, '')]
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...streetAllergenTagStyle,
            background: `${secondaryColor}22`,
            color: secondaryColor
          },
          title: allergen.description || '',
          children: ["\u26A0\uFE0F ", (allergen.name || allergen).toUpperCase()]
        }, `allergen-${i}`))]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetIngredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: accentColor,
            marginRight: '0.5em'
          },
          children: "\uD83D\uDCDD"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...streetIngredientsTextStyle,
            color: `${textColor}77`
          },
          children: [product.ingredients.slice(0, 3).join(' + '), product.ingredients.length > 3 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...streetActionButtonStyle,
          background: isHovered ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : primaryColor,
          color: '#000',
          boxShadow: isHovered ? `4px 4px 0 #000, 0 0 20px ${primaryColor}60` : `3px 3px 0 #000`,
          transform: isHovered ? 'rotate(-1deg)' : 'rotate(0deg)'
        },
        children: buttonText
      })]
    })]
  });
};

// Keyframes CSS pour le template Street
const streetKeyframesCSS = `
    @keyframes streetBounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
    }
    @keyframes streetShake {
        0%, 100% { transform: translateX(0); }
        25% { transform: translateX(-2px); }
        75% { transform: translateX(2px); }
    }
    @keyframes streetPulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }
    @keyframes streetGlow {
        0%, 100% { opacity: 0.5; }
        50% { opacity: 1; }
    }
    @keyframes streetSlide {
        from { transform: translateX(-100%); }
        to { transform: translateX(100%); }
    }
    
    /* Street Scrollbar styling */
    .street-products-scroll::-webkit-scrollbar {
        width: 10px;
    }
    .street-products-scroll::-webkit-scrollbar-track {
        background: #1a1a1a;
        border-radius: 0;
    }
    .street-products-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #ffcc00 0%, #ff3333 100%);
        border-radius: 0;
        border: 2px solid #000;
    }
    .street-products-scroll::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, #ffdd33 0%, #ff4444 100%);
    }
`;

// Styles Street
const streetContainerStyle = {
  fontFamily: "'Bebas Neue', 'Impact', 'Anton', 'Oswald', sans-serif",
  background: `
        linear-gradient(180deg, #1a1a1a 0%, #2a2a2a 50%, #1a1a1a 100%)
    `,
  color: '#ffffff',
  height: '100%',
  padding: '2em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const streetConcreteTextureStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
  opacity: 0.03,
  pointerEvents: 'none'
};
const streetGraffitiStyle = {
  position: 'absolute',
  fontSize: '2.67em',
  opacity: 0.15,
  fontWeight: 'bold',
  pointerEvents: 'none',
  zIndex: 0
};
const streetSplatStyle = {
  position: 'absolute',
  width: '150px',
  height: '150px',
  borderRadius: '50%',
  filter: 'blur(40px)',
  pointerEvents: 'none',
  zIndex: 0
};
const streetHeaderStyle = {
  position: 'relative',
  zIndex: 2,
  marginBottom: '1.5em',
  textAlign: 'center'
};
const streetTitleContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1em',
  marginBottom: '0.5em'
};
const streetTagStyle = {
  padding: '0.3em 0.8em',
  fontSize: '0.47em',
  fontWeight: '900',
  color: '#000',
  borderRadius: '2px',
  transform: 'rotate(-5deg)',
  letterSpacing: '0.1em'
};
const streetTitleStyle = {
  fontSize: '2.67em',
  fontWeight: '900',
  margin: 0,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  lineHeight: 1
};
const streetSubtitleStyle = {
  fontSize: '0.73em',
  margin: '0.5em 0 0',
  fontWeight: '400',
  letterSpacing: '0.3em',
  textTransform: 'uppercase'
};
const streetSearchContainerStyle = {
  position: 'relative',
  maxWidth: '400px',
  margin: '1.5em auto 0'
};
const streetSearchIconStyle = {
  position: 'absolute',
  left: '1em',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '0.53em',
  zIndex: 1
};
const streetSearchInputStyle = {
  width: '100%',
  padding: '1em 1em 1em 3em',
  fontSize: '0.67em',
  color: '#fff',
  background: '#000',
  border: '3px solid',
  borderRadius: '0',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: '0.1em'
};
const streetCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.75em',
  overflowX: 'auto',
  marginBottom: '1.5em',
  position: 'relative',
  zIndex: 2,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const streetCategoryTabStyle = {
  padding: '0.7em 1.5em',
  fontSize: '0.6em',
  fontWeight: '900',
  fontFamily: 'inherit',
  border: '3px solid',
  borderRadius: '0',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const streetProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em',
  position: 'relative',
  zIndex: 2
};
const streetProductsGridStyle = {
  display: 'grid',
  gap: '1.5em'
};
const streetProductCardStyle = {
  background: 'rgba(30, 30, 30, 0.95)',
  overflow: 'hidden',
  border: '3px solid #333',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative'
};
const streetStickerStyle = {
  position: 'absolute',
  top: '-5px',
  right: '-5px',
  padding: '0.4em 0.8em',
  fontSize: '0.47em',
  fontWeight: '900',
  color: '#fff',
  transform: 'rotate(15deg)',
  zIndex: 10,
  boxShadow: '2px 2px 0 #000'
};
const streetProductImageContainerStyle = {
  position: 'relative',
  height: '200px',
  overflow: 'hidden',
  background: '#000'
};
const streetProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.4s ease'
};
const streetImageOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.5) 100%)',
  pointerEvents: 'none'
};
const streetImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: '#1a1a1a'
};
const streetImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '0.75em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px',
  zIndex: 2
};
const streetImageIndicatorStyle = {
  width: '24px',
  height: '4px',
  transition: 'all 0.3s ease'
};
const streetNutriBadgeStyle = {
  position: 'absolute',
  top: '0.75em',
  left: '0.75em',
  padding: '0.3em 0.6em',
  fontSize: '0.53em',
  fontWeight: '900',
  color: '#000',
  zIndex: 2
};
const streetFloatingPriceStyle = {
  position: 'absolute',
  bottom: '0.75em',
  right: '0.75em',
  padding: '0.5em 1em',
  fontSize: '0.87em',
  fontWeight: '900',
  zIndex: 2,
  transform: 'rotate(2deg)'
};
const streetProductContentStyle = {
  padding: '1.25em',
  position: 'relative'
};
const streetProductNameStyle = {
  fontSize: '0.87em',
  fontWeight: '900',
  margin: '0 0 0.5em',
  letterSpacing: '0.02em',
  lineHeight: 1.2
};
const streetProductDescriptionStyle = {
  fontSize: '0.57em',
  margin: '0 0 0.75em',
  lineHeight: 1.5,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  fontFamily: "'Inter', sans-serif",
  fontWeight: '400'
};
const streetTagsContainerStyle = {
  display: 'flex',
  gap: '0.4em',
  flexWrap: 'wrap',
  marginBottom: '0.75em'
};
const streetProductTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.47em',
  fontWeight: '700',
  borderRadius: '2px'
};
const streetAllergenTagStyle = {
  padding: '0.25em 0.6em',
  fontSize: '0.43em',
  fontWeight: '700',
  borderRadius: '2px'
};
const streetIngredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1em'
};
const streetIngredientsTextStyle = {
  fontSize: '0.5em',
  fontFamily: "'Inter', sans-serif",
  fontWeight: '400'
};
const streetActionButtonStyle = {
  width: '100%',
  padding: '0.9em',
  fontSize: '0.67em',
  fontWeight: '900',
  fontFamily: 'inherit',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  textTransform: 'uppercase',
  letterSpacing: '0.1em'
};
const streetEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center'
};
const streetEmptyIconStyle = {
  fontSize: '3.33em',
  marginBottom: '1em'
};
const streetEmptyTitleStyle = {
  fontSize: '1.67em',
  fontWeight: '900',
  margin: '0 0 0.5em',
  letterSpacing: '0.05em'
};
const streetEmptyTextStyle = {
  fontSize: '0.73em',
  margin: 0,
  fontFamily: "'Inter', sans-serif"
};
const streetFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5em',
  marginTop: '1.5em',
  padding: '1em 0',
  borderTop: '3px solid',
  position: 'relative',
  zIndex: 2
};

// ============================================
// TEMPLATE TROPICAL (Plage/Paradisiaque)
// ============================================
const MenuCellTropical = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Tropical
  const {
    title = 'Paradise Menu',
    subtitle,
    primaryColor = '#00bcd4',
    // Turquoise
    secondaryColor = '#ff7043',
    // Corail
    accentColor = '#ffca28',
    // Sable doré
    backgroundColor,
    textColor = '#1a4a5e',
    fontFamily,
    titleFontSize = '3.5em',
    cardBorderRadius = '20px',
    cardBackground = 'rgba(255, 255, 255, 0.95)',
    priceColor = '#00897b',
    buttonText = 'Découvrir 🌴',
    searchPlaceholder = 'Rechercher un délice...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '200px',
    containerPadding = '2em',
    gridGap = '1.5em',
    showWaves = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 100);
      });
    }, 150);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#4caf50',
      'B': '#8bc34a',
      'C': '#ffca28',
      'D': '#ff9800',
      'E': '#f44336'
    };
    return colors[score] || primaryColor;
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...tropicalContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...tropicalTitleStyle,
    fontSize: titleFontSize,
    color: primaryColor
  };
  const dynamicSearchStyle = {
    ...tropicalSearchInputStyle,
    borderColor: `${primaryColor}66`
  };
  const dynamicProductsGridStyle = {
    ...tropicalProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `🌺 ${filteredProducts.length} délice${filteredProducts.length > 1 ? 's' : ''} tropical${filteredProducts.length > 1 ? 'aux' : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: tropicalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: tropicalGradientOverlayStyle
    }), showWaves && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...tropicalWaveStyle,
          bottom: 0,
          animationDelay: '0s',
          opacity: 0.6
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...tropicalWaveStyle,
          bottom: '-10px',
          animationDelay: '0.5s',
          opacity: 0.4
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...tropicalWaveStyle,
          bottom: '-20px',
          animationDelay: '1s',
          opacity: 0.2
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalDecoStyle,
        top: '5%',
        left: '3%',
        fontSize: '1.33em'
      },
      children: "\uD83C\uDF34"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalDecoStyle,
        top: '8%',
        right: '5%',
        fontSize: '1.67em'
      },
      children: "\uD83C\uDF3A"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalDecoStyle,
        top: '15%',
        left: '8%',
        fontSize: '1.33em'
      },
      children: "\uD83E\uDD65"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalDecoStyle,
        bottom: '20%',
        right: '3%',
        fontSize: '1.67em'
      },
      children: "\uD83C\uDF79"
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: tropicalHeaderStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: tropicalSunStyle,
        children: "\u2600\uFE0F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: dynamicTitleStyle,
        children: title
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...tropicalSubtitleStyle,
          color: secondaryColor
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalSearchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...tropicalSearchIconStyle,
            color: primaryColor
          },
          children: "\uD83D\uDD0D"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchStyle
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: tropicalCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TropicalCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "\uD83C\uDF0A Tous"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(TropicalCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 60,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tropical-products-scroll",
      style: tropicalProductsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...tropicalEmptyIconStyle,
            color: primaryColor
          },
          children: "\uD83C\uDFDD\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...tropicalEmptyTitleStyle,
            color: primaryColor
          },
          children: "Rien \xE0 l'horizon..."
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...tropicalEmptyTextStyle,
            color: secondaryColor
          },
          children: searchQuery ? "Essayez une autre recherche !" : "Cette catégorie est vide pour le moment"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(TropicalProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients,
            textColor
          }
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...tropicalFooterStyle,
        background: `linear-gradient(90deg, ${primaryColor}22, ${secondaryColor}22, ${accentColor}22)`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "\uD83C\uDF34"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: textColor,
          fontWeight: '500',
          letterSpacing: '0.15em',
          fontSize: '0.57em'
        },
        children: "SAVEURS DU PARADIS"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "\uD83C\uDF34"
      })]
    })]
  });
};

// Composant bouton de catégorie Tropical
const TropicalCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#00bcd4',
  secondaryColor = '#ff7043'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [hovered, setHovered] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      ...tropicalCategoryTabStyle,
      background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : hovered ? `${primaryColor}22` : 'rgba(255, 255, 255, 0.9)',
      color: isActive ? '#fff' : hovered ? primaryColor : '#1a4a5e',
      borderColor: isActive ? 'transparent' : hovered ? primaryColor : `${primaryColor}44`,
      transform: mounted ? hovered ? 'translateY(-3px)' : 'translateY(0)' : 'translateY(15px)',
      opacity: mounted ? 1 : 0,
      boxShadow: isActive ? `0 8px 25px ${primaryColor}44` : hovered ? `0 5px 15px ${primaryColor}33` : '0 2px 8px rgba(0,0,0,0.1)'
    },
    children: children
  });
};

// Composant carte produit Tropical
const TropicalProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#00bcd4',
    secondaryColor = '#ff7043',
    accentColor = '#ffca28',
    cardBackground = 'rgba(255, 255, 255, 0.95)',
    cardBorderRadius = '20px',
    imageHeight = '200px',
    priceColor = '#00897b',
    buttonText = 'Découvrir 🌴',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    textColor = '#1a4a5e'
  } = styles_properties;

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 2000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...tropicalProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius,
    boxShadow: isHovered ? `0 20px 40px ${primaryColor}33, 0 0 0 2px ${primaryColor}44` : '0 8px 25px rgba(0, 188, 212, 0.15)'
  };
  const dynamicImageContainerStyle = {
    ...tropicalProductImageContainerStyle,
    height: imageHeight,
    borderRadius: `${cardBorderRadius} ${cardBorderRadius} 0 0`
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'translateY(-10px) scale(1.02)' : 'translateY(0) scale(1)' : 'translateY(40px) scale(0.9)',
      opacity: isVisible ? 1 : 0
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalHighlightBadgeStyle,
        background: `linear-gradient(135deg, ${secondaryColor}, ${accentColor})`
      },
      children: "\uD83C\uDF1F Favori"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...tropicalProductImageStyle,
            transform: isHovered ? 'scale(1.1)' : 'scale(1)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: tropicalImageOverlayStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...tropicalImagePlaceholderStyle,
          background: `linear-gradient(135deg, ${primaryColor}33, ${secondaryColor}33)`
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '2.33em'
          },
          children: "\uD83E\uDD65"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: tropicalImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...tropicalImageIndicatorStyle,
            background: i === currentImageIndex ? '#fff' : 'rgba(255,255,255,0.5)',
            transform: i === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
          }
        }, i))
      }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          ...tropicalNutriBadgeStyle,
          background: getNutriScoreColor(product.nutrition_score)
        },
        children: product.nutrition_score
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...tropicalFloatingPriceStyle,
          background: priceColor
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: tropicalProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          ...tropicalProductNameStyle,
          color: textColor
        },
        children: product.name
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...tropicalProductDescriptionStyle,
          color: `${textColor}aa`
        },
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...tropicalProductTagStyle,
            background: `${primaryColor}22`,
            color: primaryColor
          },
          children: tag
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...tropicalAllergenTagStyle,
            background: `${secondaryColor}22`,
            color: secondaryColor
          },
          title: allergen.description || '',
          children: ["\u26A0\uFE0F ", allergen.name || allergen]
        }, `allergen-${i}`))]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalIngredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: accentColor,
            marginRight: '0.5em'
          },
          children: "\uD83E\uDD57"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...tropicalIngredientsTextStyle,
            color: `${textColor}88`
          },
          children: [product.ingredients.slice(0, 3).join(' • '), product.ingredients.length > 3 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...tropicalActionButtonStyle,
          background: isHovered ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
          boxShadow: isHovered ? `0 10px 30px ${primaryColor}44` : `0 5px 15px ${primaryColor}33`
        },
        children: buttonText
      })]
    })]
  });
};

// Keyframes CSS pour le template Tropical
const tropicalKeyframesCSS = `
    @keyframes tropicalWave {
        0% { transform: translateX(0) translateY(0); }
        50% { transform: translateX(-25px) translateY(5px); }
        100% { transform: translateX(0) translateY(0); }
    }
    @keyframes tropicalFloat {
        0%, 100% { transform: translateY(0) rotate(0deg); }
        50% { transform: translateY(-8px) rotate(3deg); }
    }
    @keyframes tropicalPulse {
        0%, 100% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.8; }
    }
    @keyframes tropicalShimmer {
        0% { background-position: -200% center; }
        100% { background-position: 200% center; }
    }
    
    /* Tropical Scrollbar styling */
    .tropical-products-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .tropical-products-scroll::-webkit-scrollbar-track {
        background: rgba(0, 188, 212, 0.1);
        border-radius: 10px;
    }
    .tropical-products-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #00bcd4 0%, #ff7043 100%);
        border-radius: 10px;
    }
    .tropical-products-scroll::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, #00acc1 0%, #ff5722 100%);
    }
`;

// Styles Tropical
const tropicalContainerStyle = {
  fontFamily: "'Poppins', 'Quicksand', 'Comfortaa', 'Nunito', sans-serif",
  background: 'linear-gradient(180deg, #87CEEB 0%, #B0E0E6 20%, #F5DEB3 80%, #DEB887 100%)',
  color: '#1a4a5e',
  height: '100%',
  padding: '2em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const tropicalGradientOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'radial-gradient(ellipse at top, rgba(255,255,255,0.4) 0%, transparent 70%)',
  pointerEvents: 'none'
};
const tropicalWaveStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  height: '100px',
  background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%2300bcd4' fill-opacity='0.3' d='M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E")`,
  backgroundSize: 'cover',
  animation: 'tropicalWave 4s ease-in-out infinite',
  pointerEvents: 'none',
  zIndex: 0
};
const tropicalDecoStyle = {
  position: 'absolute',
  opacity: 0.6,
  animation: 'tropicalFloat 4s ease-in-out infinite',
  pointerEvents: 'none',
  zIndex: 0
};
const tropicalHeaderStyle = {
  position: 'relative',
  zIndex: 2,
  marginBottom: '1.5em',
  textAlign: 'center'
};
const tropicalSunStyle = {
  fontSize: '1.33em',
  marginBottom: '0.5em',
  animation: 'tropicalPulse 3s ease-in-out infinite'
};
const tropicalTitleStyle = {
  fontSize: '2.33em',
  fontWeight: '700',
  margin: '0 0 0.5em',
  letterSpacing: '0.02em',
  textShadow: '2px 2px 4px rgba(255,255,255,0.5)'
};
const tropicalSubtitleStyle = {
  fontSize: '0.73em',
  margin: '0 0 1em',
  fontWeight: '500'
};
const tropicalSearchContainerStyle = {
  position: 'relative',
  maxWidth: '400px',
  margin: '0 auto'
};
const tropicalSearchIconStyle = {
  position: 'absolute',
  left: '1.2em',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '0.67em',
  zIndex: 1
};
const tropicalSearchInputStyle = {
  width: '100%',
  padding: '1em 1em 1em 3.2em',
  fontSize: '0.63em',
  color: '#1a4a5e',
  background: 'rgba(255, 255, 255, 0.9)',
  border: '2px solid',
  borderRadius: '30px',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  boxShadow: '0 4px 15px rgba(0, 188, 212, 0.2)',
  transition: 'all 0.3s ease'
};
const tropicalCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.75em',
  overflowX: 'auto',
  marginBottom: '1.5em',
  position: 'relative',
  zIndex: 2,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const tropicalCategoryTabStyle = {
  padding: '0.75em 1.5em',
  fontSize: '0.6em',
  fontWeight: '600',
  fontFamily: 'inherit',
  border: '2px solid',
  borderRadius: '25px',
  cursor: 'pointer',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const tropicalProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em',
  position: 'relative',
  zIndex: 2
};
const tropicalProductsGridStyle = {
  display: 'grid',
  gap: '1.5em'
};
const tropicalProductCardStyle = {
  background: 'rgba(255, 255, 255, 0.95)',
  overflow: 'hidden',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative',
  backdropFilter: 'blur(10px)'
};
const tropicalHighlightBadgeStyle = {
  position: 'absolute',
  top: '1em',
  left: '1em',
  padding: '0.4em 0.9em',
  fontSize: '0.5em',
  fontWeight: '600',
  color: '#fff',
  borderRadius: '20px',
  zIndex: 10,
  boxShadow: '0 4px 12px rgba(255, 112, 67, 0.4)'
};
const tropicalProductImageContainerStyle = {
  position: 'relative',
  height: '200px',
  overflow: 'hidden'
};
const tropicalProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.5s ease'
};
const tropicalImageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '40%',
  background: 'linear-gradient(to top, rgba(255,255,255,0.9) 0%, transparent 100%)',
  pointerEvents: 'none'
};
const tropicalImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};
const tropicalImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '1em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px',
  zIndex: 2
};
const tropicalImageIndicatorStyle = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
};
const tropicalNutriBadgeStyle = {
  position: 'absolute',
  top: '1em',
  right: '1em',
  padding: '0.3em 0.6em',
  fontSize: '0.53em',
  fontWeight: '700',
  color: '#fff',
  borderRadius: '8px',
  zIndex: 2
};
const tropicalFloatingPriceStyle = {
  position: 'absolute',
  bottom: '1em',
  right: '1em',
  padding: '0.5em 1em',
  fontSize: '0.53em',
  fontWeight: '700',
  color: '#fff',
  borderRadius: '15px',
  boxShadow: '0 4px 15px rgba(0, 137, 123, 0.4)',
  zIndex: 2
};
const tropicalProductContentStyle = {
  padding: '1.25em',
  position: 'relative'
};
const tropicalProductNameStyle = {
  fontSize: '0.53em',
  fontWeight: '600',
  margin: '0 0 0.5em',
  lineHeight: 1.3
};
const tropicalProductDescriptionStyle = {
  fontSize: '0.57em',
  margin: '0 0 0.75em',
  lineHeight: 1.6,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};
const tropicalTagsContainerStyle = {
  display: 'flex',
  gap: '0.4em',
  flexWrap: 'wrap',
  marginBottom: '0.75em'
};
const tropicalProductTagStyle = {
  padding: '0.25em 0.65em',
  fontSize: '0.47em',
  fontWeight: '600',
  borderRadius: '12px'
};
const tropicalAllergenTagStyle = {
  padding: '0.25em 0.65em',
  fontSize: '0.47em',
  fontWeight: '600',
  borderRadius: '12px'
};
const tropicalIngredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1em'
};
const tropicalIngredientsTextStyle = {
  fontSize: '0.53em',
  fontStyle: 'italic'
};
const tropicalActionButtonStyle = {
  width: '100%',
  padding: '0.85em',
  fontSize: '0.6em',
  fontWeight: '600',
  fontFamily: 'inherit',
  color: '#fff',
  border: 'none',
  borderRadius: '15px',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const tropicalEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center'
};
const tropicalEmptyIconStyle = {
  fontSize: '3.33em',
  marginBottom: '1em',
  animation: 'tropicalFloat 3s ease-in-out infinite'
};
const tropicalEmptyTitleStyle = {
  fontSize: '0.53em',
  fontWeight: '600',
  margin: '0 0 0.5em'
};
const tropicalEmptyTextStyle = {
  fontSize: '0.67em',
  margin: 0
};
const tropicalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5em',
  marginTop: '1.5em',
  padding: '1em',
  borderRadius: '15px',
  position: 'relative',
  zIndex: 2,
  fontSize: '0.67em'
};

// ============================================
// TEMPLATE MEDIEVAL (Taverne/Château)
// ============================================
const MenuCellMedieval = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [visibleCards, setVisibleCards] = (0, _react.useState)(new Set());
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Medieval
  const {
    title = 'La Taverne',
    subtitle,
    primaryColor = '#8b4513',
    // Marron cuir
    secondaryColor = '#daa520',
    // Or ancien
    accentColor = '#8b0000',
    // Rouge sang
    backgroundColor,
    textColor = '#3d2b1f',
    fontFamily,
    titleFontSize = '3.5em',
    cardBorderRadius = '0',
    cardBackground = '#f5e6c8',
    priceColor = '#8b4513',
    buttonText = 'Commander',
    searchPlaceholder = 'Chercher un mets...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '200px',
    containerPadding = '2em',
    gridGap = '1.5em',
    showTorches = true
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleCards(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleCards(prev => new Set([...prev, product.id]));
        }, index * 100);
      });
    }, 150);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#2e7d32',
      'B': '#558b2f',
      'C': '#f9a825',
      'D': '#ef6c00',
      'E': '#c62828'
    };
    return colors[score] || primaryColor;
  };

  // Styles dynamiques
  const dynamicContainerStyle = {
    ...medievalContainerStyle,
    ...(backgroundColor && {
      background: backgroundColor
    }),
    ...(fontFamily && {
      fontFamily
    }),
    padding: containerPadding,
    color: textColor,
    fontSize: `${16 * scaleFactor}px` // Base pour tous les em
  };
  const dynamicTitleStyle = {
    ...medievalTitleStyle,
    fontSize: titleFontSize,
    color: secondaryColor,
    textShadow: `2px 2px 4px ${primaryColor}`
  };
  const dynamicSearchStyle = {
    ...medievalSearchInputStyle,
    borderColor: primaryColor
  };
  const dynamicProductsGridStyle = {
    ...medievalProductsGridStyle,
    gap: gridGap
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `⚔️ ${filteredProducts.length} mets pour les braves ⚔️`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: dynamicContainerStyle,
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: medievalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: medievalParchmentTextureStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalBorderStyle,
        top: 0,
        left: 0,
        right: 0,
        borderBottom: `4px solid ${primaryColor}`
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalBorderStyle,
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: `4px solid ${primaryColor}`
      }
    }), showTorches && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalTorchStyle,
          left: '2%'
        },
        children: "\uD83D\uDD25"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalTorchStyle,
          right: '2%'
        },
        children: "\uD83D\uDD25"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCornerStyle,
        top: '10px',
        left: '10px'
      },
      children: "\u269C"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCornerStyle,
        top: '10px',
        right: '10px'
      },
      children: "\u269C"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCornerStyle,
        bottom: '10px',
        left: '10px'
      },
      children: "\u269C"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCornerStyle,
        bottom: '10px',
        right: '10px'
      },
      children: "\u269C"
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: medievalHeaderStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalShieldStyle,
          color: secondaryColor
        },
        children: "\uD83D\uDEE1\uFE0F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalOrnamentStyle,
          color: primaryColor
        },
        children: "\u2550\u2550\u2550\u2550\u2550\u2550 \u2694\uFE0F \u2550\u2550\u2550\u2550\u2550\u2550"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: dynamicTitleStyle,
        children: title
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...medievalSubtitleStyle,
          color: `${textColor}cc`
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalOrnamentStyle,
          color: primaryColor
        },
        children: "\u2550\u2550\u2550\u2550\u2550\u2550 \u2694\uFE0F \u2550\u2550\u2550\u2550\u2550\u2550"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalSearchContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...medievalSearchIconStyle,
            color: secondaryColor
          },
          children: "\uD83D\uDD0D"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: searchPlaceholder,
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          style: dynamicSearchStyle
        })]
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: medievalCategoriesContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MedievalCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: "\uD83C\uDF56 Tout"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(MedievalCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        delay: index * 60,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "medieval-products-scroll",
      style: medievalProductsScrollContainerStyle,
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalEmptyStateStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalEmptyIconStyle,
            color: secondaryColor
          },
          children: "\uD83C\uDFF0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...medievalEmptyTitleStyle,
            color: primaryColor
          },
          children: "Les r\xE9serves sont vides !"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...medievalEmptyTextStyle,
            color: `${textColor}99`
          },
          children: searchQuery ? "Aucun mets ne correspond à ta quête" : "Cette catégorie n'a point de victuailles"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...dynamicProductsGridStyle,
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(MedievalProductCard, {
          product: product,
          isVisible: visibleCards.has(product.id),
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => onProductClick?.(product),
          uri_transformer: uri_transformer,
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          index: index,
          styles_properties: {
            primaryColor,
            secondaryColor,
            accentColor,
            cardBackground,
            cardBorderRadius,
            imageHeight,
            priceColor,
            buttonText,
            showPrice,
            showDescription,
            showTags,
            showAllergens,
            showNutriScore,
            showIngredients,
            textColor
          }
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...medievalFooterStyle,
        borderColor: primaryColor
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor
        },
        children: "\u2694\uFE0F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: primaryColor,
          fontWeight: '600',
          letterSpacing: '0.15em',
          fontSize: '0.57em'
        },
        children: "FESTOYEZ BRAVES GENS"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: secondaryColor
        },
        children: "\u2694\uFE0F"
      })]
    })]
  });
};

// Composant bouton de catégorie Medieval
const MedievalCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor = '#8b4513',
  secondaryColor = '#daa520'
}) => {
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [hovered, setHovered] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      ...medievalCategoryTabStyle,
      background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : hovered ? '#f5e6c8' : '#fdf5e6',
      color: isActive ? '#fff' : primaryColor,
      borderColor: isActive ? secondaryColor : primaryColor,
      transform: mounted ? hovered ? 'translateY(-2px)' : 'translateY(0)' : 'translateY(15px)',
      opacity: mounted ? 1 : 0,
      boxShadow: isActive ? `0 4px 15px ${primaryColor}44, inset 0 -2px 0 rgba(0,0,0,0.2)` : hovered ? `0 3px 10px ${primaryColor}33` : `inset 0 -2px 0 ${primaryColor}33`
    },
    children: children
  });
};

// Composant carte produit Medieval
const MedievalProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  uri_transformer,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  index,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const intervalRef = (0, _react.useRef)(null);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  const price = getDefaultPrice(product);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#8b4513',
    secondaryColor = '#daa520',
    accentColor = '#8b0000',
    cardBackground = '#f5e6c8',
    cardBorderRadius = '0',
    imageHeight = '200px',
    priceColor = '#8b4513',
    buttonText = 'Commander',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    textColor = '#3d2b1f'
  } = styles_properties;

  // Carrousel automatique au survol
  (0, _react.useEffect)(() => {
    if (isHovered && hasMultipleImages) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, 2000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (!isHovered && product.default_image_id) {
        const defaultIndex = images.findIndex(img => img.id === product.default_image_id);
        if (defaultIndex !== -1) {
          setCurrentImageIndex(defaultIndex);
        }
      } else if (!isHovered) {
        setCurrentImageIndex(0);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isHovered, hasMultipleImages, images.length]);
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);

  // Styles dynamiques
  const dynamicCardStyle = {
    ...medievalProductCardStyle,
    background: cardBackground,
    borderRadius: cardBorderRadius,
    borderColor: isHovered ? secondaryColor : primaryColor,
    boxShadow: isHovered ? `0 15px 35px ${primaryColor}44, inset 0 0 0 2px ${secondaryColor}` : `0 5px 15px ${primaryColor}22`
  };
  const dynamicImageContainerStyle = {
    ...medievalProductImageContainerStyle,
    height: imageHeight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...dynamicCardStyle,
      transform: isVisible ? isHovered ? 'translateY(-8px)' : 'translateY(0)' : 'translateY(40px)',
      opacity: isVisible ? 1 : 0
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCardBorderStyle,
        background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
      }
    }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalHighlightBadgeStyle,
        background: accentColor
      },
      children: "\u2605 Sp\xE9cialit\xE9"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicImageContainerStyle,
      children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            ...medievalProductImageStyle,
            transform: isHovered ? 'scale(1.05)' : 'scale(1)'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: medievalImageOverlayStyle
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalImagePlaceholderStyle,
          color: secondaryColor
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '2.33em'
          },
          children: "\uD83C\uDF56"
        })
      }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: medievalImageIndicatorsStyle,
        children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalImageIndicatorStyle,
            background: i === currentImageIndex ? secondaryColor : `${secondaryColor}66`
          }
        }, i))
      }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          ...medievalNutriBadgeStyle,
          background: getNutriScoreColor(product.nutrition_score)
        },
        children: product.nutrition_score
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalFloatingPriceStyle,
          background: `linear-gradient(135deg, ${priceColor} 0%, ${secondaryColor} 100%)`
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: medievalProductContentStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalProductOrnamentStyle,
          color: secondaryColor
        },
        children: "\u2767"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          ...medievalProductNameStyle,
          color: textColor
        },
        children: product.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalProductDividerStyle,
          background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
        }
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          ...medievalProductDescriptionStyle,
          color: `${textColor}bb`
        },
        children: product.description
      }), (showTags && product.tags?.length > 0 || showAllergens && product.allergens?.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalTagsContainerStyle,
        children: [showTags && product.tags?.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            ...medievalProductTagStyle,
            background: `${primaryColor}22`,
            color: primaryColor,
            borderColor: `${primaryColor}44`
          },
          children: tag
        }, `tag-${i}`)), showAllergens && product.allergens?.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...medievalAllergenTagStyle,
            background: `${accentColor}22`,
            color: accentColor,
            borderColor: `${accentColor}44`
          },
          title: allergen.description || '',
          children: ["\u26A0 ", allergen.name || allergen]
        }, `allergen-${i}`))]
      }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalIngredientsContainerStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor,
            marginRight: '0.5em'
          },
          children: "\uD83D\uDCDC"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            ...medievalIngredientsTextStyle,
            color: `${textColor}99`
          },
          children: [product.ingredients.slice(0, 3).join(' • '), product.ingredients.length > 3 && ' ...']
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        style: {
          ...medievalActionButtonStyle,
          background: isHovered ? `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)` : `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
          borderColor: secondaryColor,
          boxShadow: isHovered ? `0 6px 20px ${primaryColor}55, inset 0 -3px 0 rgba(0,0,0,0.2)` : `inset 0 -3px 0 rgba(0,0,0,0.2)`
        },
        children: ["\u2694\uFE0F ", buttonText]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalCardBorderStyle,
        background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
      }
    })]
  });
};

// Keyframes CSS pour le template Medieval
const medievalKeyframesCSS = `
    @keyframes medievalFlicker {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.8; transform: scale(1.1); }
    }
    @keyframes medievalFloat {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
    }
    @keyframes medievalGlow {
        0%, 100% { text-shadow: 0 0 5px rgba(218, 165, 32, 0.5); }
        50% { text-shadow: 0 0 20px rgba(218, 165, 32, 0.8); }
    }
    
    /* Medieval Scrollbar styling */
    .medieval-products-scroll::-webkit-scrollbar {
        width: 12px;
    }
    .medieval-products-scroll::-webkit-scrollbar-track {
        background: #f5e6c8;
        border: 2px solid #8b4513;
    }
    .medieval-products-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #8b4513 0%, #daa520 50%, #8b4513 100%);
        border: 2px solid #8b4513;
    }
    .medieval-products-scroll::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, #a0522d 0%, #ffd700 50%, #a0522d 100%);
    }
`;

// Styles Medieval
const medievalContainerStyle = {
  fontFamily: "'MedievalSharp', 'Uncial Antiqua', 'Almendra', 'Cinzel', Georgia, serif",
  background: `
        linear-gradient(180deg, #3d2b1f 0%, #4a3728 10%, #5c4033 50%, #4a3728 90%, #3d2b1f 100%)
    `,
  color: '#3d2b1f',
  height: '100%',
  padding: '2em',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
const medievalParchmentTextureStyle = {
  position: 'absolute',
  top: '20px',
  left: '20px',
  right: '20px',
  bottom: '20px',
  background: `
        linear-gradient(135deg, #fdf5e6 0%, #f5e6c8 25%, #fdf5e6 50%, #f5e6c8 75%, #fdf5e6 100%)
    `,
  boxShadow: 'inset 0 0 50px rgba(139, 69, 19, 0.3)',
  zIndex: 0
};
const medievalBorderStyle = {
  position: 'absolute',
  height: '4px',
  zIndex: 1
};
const medievalTorchStyle = {
  position: 'absolute',
  top: '15%',
  fontSize: '1.67em',
  animation: 'medievalFlicker 0.5s infinite',
  zIndex: 3,
  filter: 'drop-shadow(0 0 10px #ff6600)'
};
const medievalCornerStyle = {
  position: 'absolute',
  fontSize: '0.67em',
  color: '#8b4513',
  zIndex: 3
};
const medievalHeaderStyle = {
  position: 'relative',
  zIndex: 2,
  marginBottom: '1.5em',
  textAlign: 'center',
  padding: '0 2em'
};
const medievalShieldStyle = {
  fontSize: '1.33em',
  marginBottom: '0.5em',
  animation: 'medievalFloat 3s ease-in-out infinite'
};
const medievalOrnamentStyle = {
  fontSize: '0.6em',
  letterSpacing: '0.3em',
  marginBottom: '0.5em'
};
const medievalTitleStyle = {
  fontSize: '2.33em',
  fontWeight: '400',
  margin: '0 0 0.5em',
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
};
const medievalSubtitleStyle = {
  fontSize: '0.73em',
  margin: '0 0 0.5em',
  fontStyle: 'italic'
};
const medievalSearchContainerStyle = {
  position: 'relative',
  maxWidth: '350px',
  margin: '1em auto 0'
};
const medievalSearchIconStyle = {
  position: 'absolute',
  left: '1em',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '0.67em',
  zIndex: 1
};
const medievalSearchInputStyle = {
  width: '100%',
  padding: '0.9em 1em 0.9em 3em',
  fontSize: '0.63em',
  color: '#3d2b1f',
  background: '#fdf5e6',
  border: '2px solid',
  borderRadius: '0',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
  fontStyle: 'italic'
};
const medievalCategoriesContainerStyle = {
  display: 'flex',
  gap: '0.5em',
  overflowX: 'auto',
  marginBottom: '1.5em',
  position: 'relative',
  zIndex: 2,
  padding: '0 2em',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};
const medievalCategoryTabStyle = {
  padding: '0.6em 1.2em',
  fontSize: '0.57em',
  fontWeight: '500',
  fontFamily: 'inherit',
  border: '2px solid',
  borderRadius: '0',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  whiteSpace: 'nowrap',
  flexShrink: 0
};
const medievalProductsScrollContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingRight: '0.5em',
  marginRight: '-0.5em',
  position: 'relative',
  zIndex: 2,
  padding: '0 2em'
};
const medievalProductsGridStyle = {
  display: 'grid',
  gap: '1.5em'
};
const medievalProductCardStyle = {
  background: '#f5e6c8',
  overflow: 'hidden',
  border: '3px solid',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  cursor: 'pointer',
  position: 'relative'
};
const medievalCardBorderStyle = {
  height: '3px'
};
const medievalHighlightBadgeStyle = {
  position: 'absolute',
  top: '1em',
  left: '1em',
  padding: '0.35em 0.8em',
  fontSize: '0.47em',
  fontWeight: '600',
  color: '#fff',
  zIndex: 10,
  fontStyle: 'italic'
};
const medievalProductImageContainerStyle = {
  position: 'relative',
  height: '200px',
  overflow: 'hidden',
  background: '#e6d5b8'
};
const medievalProductImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'all 0.5s ease',
  filter: 'sepia(15%)'
};
const medievalImageOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, transparent 60%, rgba(245, 230, 200, 0.8) 100%)',
  pointerEvents: 'none'
};
const medievalImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: 'linear-gradient(135deg, #e6d5b8, #f5e6c8)'
};
const medievalImageIndicatorsStyle = {
  position: 'absolute',
  bottom: '1em',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px',
  zIndex: 2
};
const medievalImageIndicatorStyle = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  transition: 'all 0.3s ease'
};
const medievalNutriBadgeStyle = {
  position: 'absolute',
  top: '1em',
  right: '1em',
  padding: '0.3em 0.5em',
  fontSize: '0.5em',
  fontWeight: '700',
  color: '#fff',
  zIndex: 2
};
const medievalFloatingPriceStyle = {
  position: 'absolute',
  bottom: '1em',
  right: '1em',
  padding: '0.5em 1em',
  fontSize: '0.73em',
  fontWeight: '600',
  color: '#fff',
  zIndex: 2,
  clipPath: 'polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%)'
};
const medievalProductContentStyle = {
  padding: '1.25em',
  position: 'relative',
  textAlign: 'center'
};
const medievalProductOrnamentStyle = {
  fontSize: '0.53em',
  marginBottom: '0.25em'
};
const medievalProductNameStyle = {
  fontSize: '0.53em',
  fontWeight: '500',
  margin: '0 0 0.5em',
  lineHeight: 1.3
};
const medievalProductDividerStyle = {
  height: '2px',
  width: '60px',
  margin: '0 auto 0.75em'
};
const medievalProductDescriptionStyle = {
  fontSize: '0.57em',
  margin: '0 0 0.75em',
  lineHeight: 1.6,
  fontStyle: 'italic',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
};
const medievalTagsContainerStyle = {
  display: 'flex',
  gap: '0.4em',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '0.75em'
};
const medievalProductTagStyle = {
  padding: '0.2em 0.5em',
  fontSize: '0.47em',
  fontWeight: '500',
  border: '1px solid'
};
const medievalAllergenTagStyle = {
  padding: '0.2em 0.5em',
  fontSize: '0.47em',
  fontWeight: '500',
  border: '1px solid'
};
const medievalIngredientsContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1em'
};
const medievalIngredientsTextStyle = {
  fontSize: '0.5em',
  fontStyle: 'italic'
};
const medievalActionButtonStyle = {
  width: '100%',
  padding: '0.8em',
  fontSize: '0.6em',
  fontWeight: '600',
  fontFamily: 'inherit',
  color: '#fff',
  border: '2px solid',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const medievalEmptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5em 2em',
  textAlign: 'center'
};
const medievalEmptyIconStyle = {
  fontSize: '3.33em',
  marginBottom: '1em',
  animation: 'medievalFloat 3s ease-in-out infinite'
};
const medievalEmptyTitleStyle = {
  fontSize: '0.53em',
  fontWeight: '500',
  margin: '0 0 0.5em'
};
const medievalEmptyTextStyle = {
  fontSize: '0.67em',
  margin: 0,
  fontStyle: 'italic'
};
const medievalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5em',
  marginTop: '1.5em',
  padding: '1em',
  borderTop: '3px solid',
  position: 'relative',
  zIndex: 2,
  margin: '1.5em 2em 0'
};

// ============================================
// TEMPLATE LIGHT (Performance optimisée)
// ============================================
// Ce template est conçu pour être le plus léger possible :
// - Pas d'animations CSS
// - Pas de gradients complexes
// - Pas de filtres (blur, sepia, etc.)
// - Pas de box-shadows lourds
// - Couleurs solides uniquement
// - Transitions minimales
// - Structure DOM simplifiée

const MenuCellLight = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées avec valeurs par défaut Light
  const {
    title = 'Menu',
    subtitle,
    primaryColor = '#2563eb',
    secondaryColor = '#64748b',
    accentColor = '#10b981',
    backgroundColor = '#ffffff',
    textColor = '#1e293b',
    fontFamily = 'system-ui, -apple-system, sans-serif',
    titleFontSize = '2em',
    cardBorderRadius = '8px',
    cardBackground = '#ffffff',
    priceColor = '#10b981',
    buttonText = 'Voir',
    searchPlaceholder = 'Rechercher...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    imageHeight = '160px',
    containerPadding = '1em',
    gridGap = '1em'
  } = normalizedProps;

  // Extraire toutes les catégories uniques
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);

  // Helpers simples
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#22c55e',
      'B': '#84cc16',
      'C': '#eab308',
      'D': '#f97316',
      'E': '#ef4444'
    };
    return colors[score] || secondaryColor;
  };

  // Générer le sous-titre
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} produit${filteredProducts.length > 1 ? 's' : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: {
      fontFamily,
      background: backgroundColor,
      color: textColor,
      height: '100%',
      padding: containerPadding,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontSize: `${16 * scaleFactor}px` // Base pour tous les em
    },
    ...rest,
    children: [showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: {
        marginBottom: '1em'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: {
          fontSize: titleFontSize,
          fontWeight: '600',
          margin: '0 0 0.25em',
          color: primaryColor
        },
        children: title
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: '0.58em',
          color: secondaryColor,
          margin: '0 0 0.75em'
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: "text",
        placeholder: searchPlaceholder,
        value: searchQuery,
        onChange: e => setSearchQuery(e.target.value),
        style: {
          width: '100%',
          maxWidth: '300px',
          padding: '0.5em 0.75em',
          fontSize: '0.58em',
          color: textColor,
          background: '#f8fafc',
          border: `1px solid #e2e8f0`,
          borderRadius: '6px',
          outline: 'none',
          boxSizing: 'border-box'
        }
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      style: {
        display: 'flex',
        gap: '0.5em',
        overflowX: 'auto',
        marginBottom: '1em',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: () => setActiveCategory('all'),
        style: {
          padding: '0.4em 0.8em',
          fontSize: '0.53em',
          fontWeight: '500',
          background: activeCategory === 'all' ? primaryColor : '#f1f5f9',
          color: activeCategory === 'all' ? '#fff' : textColor,
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0
        },
        children: "Tous"
      }), categories.map(category => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: () => setActiveCategory(category.id),
        style: {
          padding: '0.4em 0.8em',
          fontSize: '0.53em',
          fontWeight: '500',
          background: activeCategory === category.id ? primaryColor : '#f1f5f9',
          color: activeCategory === category.id ? '#fff' : textColor,
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0
        },
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden'
      },
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3em 1em',
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: '1.67em',
            marginBottom: '0.5em',
            opacity: 0.5
          },
          children: "\uD83C\uDF7D\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            fontSize: '0.83em',
            fontWeight: '500',
            margin: '0 0 0.25em',
            color: textColor
          },
          children: "Aucun produit trouv\xE9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            fontSize: '0.58em',
            color: secondaryColor,
            margin: 0
          },
          children: searchQuery ? "Essayez une autre recherche" : "Cette catégorie est vide"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: gridGap
        },
        children: filteredProducts.map(product => {
          const image = getDefaultImage(product);
          const price = getDefaultPrice(product);
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            onClick: () => onProductClick?.(product),
            style: {
              background: cardBackground,
              borderRadius: cardBorderRadius,
              border: '1px solid #e2e8f0',
              overflow: 'hidden',
              cursor: 'pointer'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                height: imageHeight,
                background: '#f1f5f9',
                position: 'relative'
              },
              children: [image ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: uri_transformer(image),
                alt: product.name,
                style: {
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                },
                loading: "lazy"
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  fontSize: '1.33em',
                  opacity: 0.3
                },
                children: "\uD83C\uDF7D\uFE0F"
              }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  position: 'absolute',
                  top: '0.5em',
                  left: '0.5em',
                  padding: '0.2em 0.5em',
                  fontSize: '0.43em',
                  fontWeight: '600',
                  background: accentColor,
                  color: '#fff',
                  borderRadius: '3px'
                },
                children: "\u2605"
              }), showNutriScore && product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  position: 'absolute',
                  top: '0.5em',
                  right: '0.5em',
                  padding: '0.15em 0.4em',
                  fontSize: '0.47em',
                  fontWeight: '700',
                  background: getNutriScoreColor(product.nutrition_score),
                  color: '#fff',
                  borderRadius: '3px'
                },
                children: product.nutrition_score
              }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  position: 'absolute',
                  bottom: '0.5em',
                  right: '0.5em',
                  padding: '0.25em 0.5em',
                  fontSize: '0.6em',
                  fontWeight: '700',
                  background: priceColor,
                  color: '#fff',
                  borderRadius: '4px'
                },
                children: formatPrice(price)
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                padding: '0.75em'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                style: {
                  fontSize: '0.63em',
                  fontWeight: '600',
                  margin: '0 0 0.25em',
                  color: textColor,
                  lineHeight: 1.3
                },
                children: product.name
              }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                style: {
                  fontSize: '0.5em',
                  color: secondaryColor,
                  margin: '0 0 0.5em',
                  lineHeight: 1.4,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                },
                children: product.description
              }), showTags && product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: 'flex',
                  gap: '0.25em',
                  flexWrap: 'wrap',
                  marginBottom: '0.5em'
                },
                children: product.tags.slice(0, 3).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  style: {
                    padding: '0.1em 0.35em',
                    fontSize: '0.43em',
                    background: '#f1f5f9',
                    color: secondaryColor,
                    borderRadius: '3px'
                  },
                  children: tag
                }, i))
              }), showAllergens && product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: 'flex',
                  gap: '0.25em',
                  flexWrap: 'wrap',
                  marginBottom: '0.5em'
                },
                children: product.allergens.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  style: {
                    padding: '0.1em 0.35em',
                    fontSize: '0.43em',
                    background: '#fef2f2',
                    color: '#dc2626',
                    borderRadius: '3px'
                  },
                  children: ["\u26A0 ", allergen.name || allergen]
                }, i))
              }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                style: {
                  fontSize: '0.47em',
                  color: '#94a3b8',
                  margin: '0 0 0.5em',
                  lineHeight: 1.3
                },
                children: [product.ingredients.slice(0, 3).join(' • '), product.ingredients.length > 3 && ' ...']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                style: {
                  width: '100%',
                  padding: '0.5em',
                  fontSize: '0.53em',
                  fontWeight: '500',
                  color: '#fff',
                  background: primaryColor,
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                },
                children: buttonText
              })]
            })]
          }, product.id);
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        marginTop: '0.75em',
        paddingTop: '0.75em',
        borderTop: '1px solid #e2e8f0',
        textAlign: 'center',
        fontSize: '0.5em',
        color: secondaryColor
      },
      children: [filteredProducts.length, " / ", products.length, " produits"]
    })]
  });
};

// ============================================
// TEMPLATE FRITERIE - "Chez Nenette"
// Style chaleureux, convivial, ambiance belge
// ============================================

const MenuCellFriterie = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [selectedCategory, setSelectedCategory] = (0, _react.useState)('all');
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [hoveredProduct, setHoveredProduct] = (0, _react.useState)(null);
  const [visibleProducts, setVisibleProducts] = (0, _react.useState)(new Set());
  const [selectedProduct, setSelectedProduct] = (0, _react.useState)(null);
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisables avec valeurs par défaut Friterie
  const {
    title = 'Chez Nenette',
    subtitle = 'La vraie frite belge depuis 1962',
    primaryColor = '#f4a020',
    // Jaune frite doré
    secondaryColor = '#c41e3a',
    // Rouge ketchup
    accentColor = '#8b4513',
    // Brun sauce
    backgroundColor = '#1a0f0a',
    // Brun foncé chaleureux
    textColor = '#fff8e7',
    // Blanc crème
    fontFamily = "'Fredoka One', 'Comic Sans MS', cursive",
    titleFontSize = '1.6em',
    cardBorderRadius = '16px',
    priceColor = '#c41e3a',
    buttonText = '🍟 Je commande !',
    searchPlaceholder = '🔍 Chercher une spécialité...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    imageHeight = '140px',
    containerPadding = '1em',
    gridGap = '1.2em',
    showEmoji = true,
    footerText = 'Faites avec ❤️ et de la bonne graisse'
  } = normalizedProps;

  // Extraire les catégories
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.category) {
        cats.set(product.category.id || product.category.name, product.category);
      }
      if (product.categories) {
        product.categories.forEach(cat => {
          cats.set(cat.id || cat.name, cat);
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (product.is_active === false) return false;

      // Filtre par catégorie
      if (selectedCategory !== 'all') {
        const hasCategory = product.category?.id === selectedCategory || product.category?.name === selectedCategory || product.categories?.some(c => c.id === selectedCategory || c.name === selectedCategory);
        if (!hasCategory) return false;
      }

      // Filtre par recherche
      if (searchTerm) {
        const query = searchTerm.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, selectedCategory, searchTerm]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleProducts(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleProducts(prev => new Set([...prev, product.id]));
        }, index * 80);
      });
    }, 100);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers pour récupérer les données du produit
  const getDefaultImage = product => {
    if (product.image_uri) return uri_transformer(product.image_uri);
    if (product.image_url) return uri_transformer(product.image_url);
    if (product.images && product.images.length > 0) {
      const img = product.images[0];
      return uri_transformer(img.uri || img.image_url || img.url || img);
    }
    if (product.default_image_id && product.images) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return uri_transformer(img.uri || img.image_url || img.url);
    }
    return null;
  };
  const getDefaultPrice = product => {
    if (product.price !== undefined && product.price !== null) return product.price;
    if (product.prices && product.prices.length > 0) {
      if (product.default_price_id) {
        const price = product.prices.find(p => p.id === product.default_price_id);
        if (price) return price.price;
      }
      return product.prices[0]?.price;
    }
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].price;
    }
    return null;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85bb2f',
      'C': '#fecb02',
      'D': '#ee8100',
      'E': '#e63e11'
    };
    return colors[score?.toUpperCase()] || '#999';
  };

  // Emojis selon le type de produit
  const getProductEmoji = product => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('frite') || name.includes('frit')) return '🍟';
    if (name.includes('burger') || name.includes('hamburger')) return '🍔';
    if (name.includes('sauce')) return '🥫';
    if (name.includes('bière') || name.includes('beer')) return '🍺';
    if (name.includes('soda') || name.includes('coca') || name.includes('boisson')) return '🥤';
    if (name.includes('glace') || name.includes('ice')) return '🍦';
    if (name.includes('poulet') || name.includes('chicken') || name.includes('nugget')) return '🍗';
    if (name.includes('saucisse') || name.includes('fricadelle') || name.includes('cervela') || name.includes('boulet')) return '🌭';
    if (name.includes('fish') || name.includes('poisson')) return '🐟';
    if (name.includes('steak') || name.includes('viande')) return '🥩';
    if (name.includes('salade')) return '🥗';
    if (name.includes('pain') || name.includes('baguette')) return '🥖';
    return '🍴';
  };
  const handleProductClick = product => {
    setSelectedProduct(product);
  };
  const closeModal = () => {
    setSelectedProduct(null);
  };
  const keyframes = `
        @keyframes friterieFloat {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            25% { transform: translateY(-5px) rotate(2deg); }
            75% { transform: translateY(-3px) rotate(-2deg); }
        }
        @keyframes friterieSizzle {
            0%, 100% { opacity: 0.6; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.05); }
        }
        @keyframes friterieSlideIn {
            from { opacity: 0; transform: translateY(30px) scale(0.9); }
            to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes friterieSteam {
            0% { opacity: 0; transform: translateY(0) scale(0.5); }
            50% { opacity: 0.6; transform: translateY(-10px) scale(1); }
            100% { opacity: 0; transform: translateY(-20px) scale(1.2); }
        }
        @keyframes friterieGlow {
            0%, 100% { box-shadow: 0 0 20px ${primaryColor}40; }
            50% { box-shadow: 0 0 35px ${primaryColor}60, 0 0 50px ${secondaryColor}30; }
        }
        @keyframes friterieNeon {
            0%, 100% { text-shadow: 0 0 10px ${primaryColor}, 0 0 20px ${primaryColor}, 0 0 30px ${secondaryColor}; }
            50% { text-shadow: 0 0 5px ${primaryColor}, 0 0 10px ${primaryColor}, 0 0 15px ${secondaryColor}; }
        }
        @keyframes friterieModalIn {
            from { opacity: 0; transform: scale(0.9) translateY(20px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes friterieBubble {
            0% { transform: translateY(0) scale(1); opacity: 0.6; }
            50% { transform: translateY(-15px) scale(1.2); opacity: 1; }
            100% { transform: translateY(-30px) scale(0.8); opacity: 0; }
        }
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: {
      width: '100%',
      height: '100%',
      background: `
                radial-gradient(ellipse at top, ${backgroundColor} 0%, #0d0705 100%),
                repeating-linear-gradient(
                    45deg,
                    transparent,
                    transparent 10px,
                    ${accentColor}08 10px,
                    ${accentColor}08 20px
                )
            `,
      color: textColor,
      fontFamily: fontFamily,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
      padding: containerPadding,
      boxSizing: 'border-box',
      fontSize: `${16 * scaleFactor}px` // Base pour tous les em
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframes
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'absolute',
        inset: 0,
        opacity: 0.03,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Crect x='25' y='5' width='8' height='50' rx='3' fill='%23f4a020' transform='rotate(15 30 30)'/%3E%3Crect x='35' y='8' width='6' height='45' rx='2' fill='%23f4a020' transform='rotate(-10 30 30)'/%3E%3Crect x='15' y='10' width='7' height='40' rx='2' fill='%23f4a020' transform='rotate(5 30 30)'/%3E%3C/svg%3E")`,
        backgroundSize: '60px 60px',
        pointerEvents: 'none'
      }
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        textAlign: 'center',
        marginBottom: '1.25em',
        position: 'relative',
        zIndex: 1
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'inline-block',
          padding: '0.75em 2.5em',
          background: `linear-gradient(180deg, ${accentColor}40 0%, ${backgroundColor} 100%)`,
          borderRadius: '12px',
          border: `3px solid ${primaryColor}`,
          boxShadow: `
                            0 0 20px ${primaryColor}50,
                            inset 0 -5px 20px ${accentColor}30
                        `,
          position: 'relative'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
          style: {
            margin: 0,
            fontSize: titleFontSize,
            fontWeight: 400,
            color: primaryColor,
            textShadow: `
                                0 0 10px ${primaryColor},
                                0 0 20px ${primaryColor},
                                0 0 30px ${primaryColor}80,
                                0 0 40px ${secondaryColor}50
                            `,
            animation: 'friterieNeon 2s ease-in-out infinite',
            letterSpacing: '2px'
          },
          children: ["\uD83C\uDF5F ", title, " \uD83C\uDF5F"]
        }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            margin: '0.5em 0 0',
            fontSize: '0.58em',
            color: `${textColor}99`,
            fontFamily: "'Georgia', serif",
            fontStyle: 'italic'
          },
          children: subtitle
        })]
      })
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        marginBottom: '1em',
        position: 'relative',
        zIndex: 1
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: "text",
        placeholder: searchPlaceholder,
        value: searchTerm,
        onChange: e => setSearchTerm(e.target.value),
        style: {
          width: '100%',
          padding: '0.875em 1.25em',
          fontSize: '0.67em',
          fontFamily: "'Georgia', serif",
          background: `linear-gradient(180deg, #2a2018 0%, #1a1208 100%)`,
          border: `2px solid ${accentColor}`,
          borderRadius: '10px',
          color: textColor,
          outline: 'none',
          boxShadow: `inset 0 2px 10px rgba(0,0,0,0.5)`,
          boxSizing: 'border-box'
        }
      })
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: 'flex',
        overflowX: 'auto',
        gap: '0.625em',
        marginBottom: '1.25em',
        padding: '0.75em',
        background: `linear-gradient(180deg, ${accentColor}30 0%, transparent 100%)`,
        borderRadius: '10px',
        border: `2px dashed ${primaryColor}50`,
        zIndex: 1,
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FriterieCategoryButton, {
        isActive: selectedCategory === 'all',
        onClick: () => setSelectedCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        scaleFactor: scaleFactor,
        children: "\uD83C\uDF7D\uFE0F Tout"
      }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(FriterieCategoryButton, {
        isActive: selectedCategory === (category.id || category.name),
        onClick: () => setSelectedCategory(category.id || category.name),
        delay: index * 0.05,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        scaleFactor: scaleFactor,
        children: category.name
      }, category.id || category.name))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '0.5em',
        zIndex: 1
      },
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          textAlign: 'center',
          padding: '3.75em',
          color: `${textColor}60`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: '2.67em',
            marginBottom: '1em',
            animation: 'friterieFloat 2s ease-in-out infinite'
          },
          children: "\uD83C\uDF5F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: '0.5em',
            fontWeight: 600
          },
          children: "Aucun produit trouv\xE9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: '0.58em',
            marginTop: '0.5em',
            opacity: 0.7
          },
          children: "Essayez une autre recherche !"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: gridGap
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(FriterieProductCard, {
          product: product,
          isVisible: visibleProducts.has(product.id),
          isHovered: hoveredProduct === product.id,
          onMouseEnter: () => setHoveredProduct(product.id),
          onMouseLeave: () => setHoveredProduct(null),
          onClick: () => handleProductClick(product),
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          getProductEmoji: getProductEmoji,
          index: index,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          textColor: textColor,
          accentColor: accentColor,
          cardBorderRadius: cardBorderRadius,
          imageHeight: imageHeight,
          priceColor: priceColor,
          buttonText: buttonText,
          showPrice: showPrice,
          showDescription: showDescription,
          showTags: showTags,
          showAllergens: showAllergens,
          showNutriScore: showNutriScore,
          showEmoji: showEmoji,
          scaleFactor: scaleFactor
        }, product.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        marginTop: '0.75em',
        padding: '0.75em',
        background: `linear-gradient(180deg, transparent 0%, ${accentColor}20 100%)`,
        borderTop: `2px dashed ${primaryColor}40`,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '0.8125em',
        zIndex: 1
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        style: {
          color: `${textColor}70`
        },
        children: ["\uD83C\uDF5F ", filteredProducts.length, " sp\xE9cialit\xE9", filteredProducts.length > 1 ? 's' : '']
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: primaryColor,
          fontStyle: 'italic',
          fontFamily: "'Georgia', serif"
        },
        children: footerText
      })]
    }), selectedProduct && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductDetailModal.default, {
      product: selectedProduct,
      onClose: closeModal,
      uri_transformer: uri_transformer,
      template_name: "friterie",
      styles_properties: {
        primaryColor,
        secondaryColor,
        accentColor,
        backgroundColor,
        textColor,
        priceColor
      }
    })]
  });
};

// Modal produit Friterie
const FriterieProductModal = ({
  product,
  onClose,
  onAddToCart,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  getProductEmoji,
  primaryColor,
  secondaryColor,
  accentColor,
  backgroundColor,
  textColor,
  buttonText,
  showPrice,
  showDescription,
  showAllergens,
  showNutriScore,
  scaleFactor = 1
}) => {
  const imageUrl = getDefaultImage(product);
  const price = getDefaultPrice(product);
  const emoji = getProductEmoji(product);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: onClose,
      style: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(8px)',
        zIndex: 1000,
        animation: 'friterieFadeIn 0.3s ease'
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1001,
        padding: '1em',
        pointerEvents: 'none'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          width: '90%',
          maxWidth: '500px',
          maxHeight: '90vh',
          background: `linear-gradient(165deg, #2a1f15 0%, ${backgroundColor} 100%)`,
          borderRadius: '20px',
          border: `4px solid ${primaryColor}`,
          boxShadow: `
                        0 30px 80px rgba(0, 0, 0, 0.7),
                        0 0 60px ${primaryColor}30,
                        inset 0 1px 0 ${primaryColor}20
                    `,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          animation: 'friterieModalIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
          pointerEvents: 'auto'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            position: 'relative',
            height: '220px',
            overflow: 'hidden',
            background: `linear-gradient(180deg, ${accentColor}30 0%, transparent 100%)`
          },
          children: [imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: imageUrl,
            alt: product.name,
            style: {
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(135deg, ${accentColor}40 0%, ${accentColor}20 100%)`,
              fontSize: '80px'
            },
            children: emoji
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '60%',
              background: `linear-gradient(to top, ${backgroundColor} 0%, transparent 100%)`,
              pointerEvents: 'none'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: onClose,
            style: {
              position: 'absolute',
              top: '12px',
              right: '12px',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0,0,0,0.6)',
              border: `2px solid ${primaryColor}`,
              borderRadius: '50%',
              color: textColor,
              fontSize: '20px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            },
            children: "\u2715"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              top: '12px',
              left: '12px',
              fontSize: '40px',
              filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.5))',
              animation: 'friterieFloat 2s ease-in-out infinite'
            },
            children: emoji
          }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: '15px',
              right: '15px',
              background: `linear-gradient(135deg, ${secondaryColor} 0%, #8b0000 100%)`,
              color: '#fff',
              padding: '10px 20px',
              borderRadius: '25px',
              fontSize: '0.67em',
              fontWeight: 700,
              fontFamily: "'Fredoka One', cursive",
              boxShadow: `0 4px 20px ${secondaryColor}70`
            },
            children: formatPrice(price)
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            padding: '1.5em',
            overflowY: 'auto',
            flex: 1
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            style: {
              margin: '0 0 0.75em',
              fontSize: '1.17em',
              fontWeight: 600,
              color: primaryColor,
              fontFamily: "'Fredoka One', cursive",
              textShadow: `0 0 20px ${primaryColor}40`
            },
            children: product.name
          }), product.category?.name && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              display: 'inline-block',
              padding: '6px 14px',
              background: `${accentColor}50`,
              borderRadius: '15px',
              fontSize: '0.58em',
              color: primaryColor,
              fontWeight: 600,
              border: `1px solid ${accentColor}`,
              marginBottom: '1em'
            },
            children: product.category.name
          }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              margin: '0 0 1.25em',
              fontSize: '0.67em',
              color: `${textColor}cc`,
              lineHeight: 1.6,
              fontFamily: "'Georgia', serif",
              fontStyle: 'italic'
            },
            children: product.description
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
              marginBottom: '1.25em'
            },
            children: showNutriScore && product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 14px',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '10px',
                border: '1px solid rgba(255,255,255,0.1)'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: `${textColor}80`,
                  fontSize: '0.58em'
                },
                children: "Nutri-Score"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  padding: '4px 10px',
                  background: getNutriScoreColor(product.nutriscore),
                  borderRadius: '6px',
                  fontSize: '0.58em',
                  fontWeight: 700,
                  color: '#fff'
                },
                children: product.nutriscore.toUpperCase()
              })]
            })
          }), showAllergens && product.allergens && product.allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              padding: '1em',
              background: `${secondaryColor}15`,
              borderRadius: '12px',
              border: `1px solid ${secondaryColor}40`,
              marginBottom: '1.25em'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '8px',
                color: secondaryColor,
                fontWeight: 600,
                fontSize: '0.9375em'
              },
              children: "\u26A0\uFE0F Allerg\xE8nes"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
              },
              children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  padding: '4px 10px',
                  background: `${secondaryColor}20`,
                  borderRadius: '8px',
                  fontSize: '0.8125em',
                  color: `${textColor}cc`
                },
                children: typeof allergen === 'string' ? allergen : allergen.name
              }, i))
            })]
          }), product.ingredients && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              padding: '1em',
              background: 'rgba(255,255,255,0.03)',
              borderRadius: '12px',
              border: '1px solid rgba(255,255,255,0.08)'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                color: primaryColor,
                fontWeight: 600,
                fontSize: '0.9375em',
                marginBottom: '8px'
              },
              children: "\uD83D\uDCDD Ingr\xE9dients"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              style: {
                margin: 0,
                fontSize: '0.58em',
                color: `${textColor}99`,
                lineHeight: 1.5
              },
              children: product.ingredients
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            padding: '1.25em 1.5em',
            borderTop: `2px dashed ${primaryColor}30`,
            background: `linear-gradient(180deg, transparent 0%, ${accentColor}15 100%)`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: onAddToCart,
            style: {
              width: '100%',
              padding: '1em',
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
              border: 'none',
              borderRadius: '12px',
              color: '#1a0f0a',
              fontSize: '0.5em',
              fontWeight: 700,
              fontFamily: "'Fredoka One', cursive",
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              boxShadow: `0 6px 25px ${primaryColor}50`,
              transition: 'all 0.3s ease'
            },
            children: buttonText
          })
        })]
      })
    })]
  });
};
const FriterieCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor,
  secondaryColor,
  scaleFactor = 1
}) => {
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      padding: '0.625em 1.25em',
      fontSize: '0.58em',
      fontWeight: 600,
      fontFamily: "'Fredoka One', cursive",
      background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : isHovered ? `linear-gradient(135deg, ${primaryColor}30 0%, ${secondaryColor}20 100%)` : 'rgba(255,255,255,0.05)',
      color: isActive ? '#1a0f0a' : '#fff8e7',
      border: `2px solid ${isActive ? primaryColor : 'rgba(255,255,255,0.2)'}`,
      borderRadius: '25px',
      cursor: 'pointer',
      transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
      transform: isHovered && !isActive ? 'scale(1.05)' : 'scale(1)',
      boxShadow: isActive ? `0 4px 20px ${primaryColor}50, inset 0 -2px 10px rgba(0,0,0,0.2)` : 'none',
      animation: `friterieSlideIn 0.4s ease ${delay}s both`,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      whiteSpace: 'nowrap',
      flexShrink: 0
    },
    children: children
  });
};
const FriterieProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  getProductEmoji,
  index,
  primaryColor,
  secondaryColor,
  textColor,
  accentColor,
  cardBorderRadius,
  imageHeight,
  priceColor,
  buttonText,
  showPrice,
  showDescription,
  showTags,
  showAllergens,
  showNutriScore,
  showEmoji,
  scaleFactor = 1
}) => {
  const imageUrl = getDefaultImage(product);
  const price = getDefaultPrice(product);
  const emoji = getProductEmoji(product);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    style: {
      background: isHovered ? `linear-gradient(145deg, #2a1f15 0%, #1a0f08 100%)` : `linear-gradient(145deg, #221810 0%, #150c06 100%)`,
      borderRadius: cardBorderRadius,
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
      transform: isVisible ? isHovered ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)' : 'translateY(40px) scale(0.9)',
      opacity: isVisible ? 1 : 0,
      border: `3px solid ${isHovered ? primaryColor : accentColor}50`,
      boxShadow: isHovered ? `0 15px 40px rgba(0,0,0,0.5), 0 0 30px ${primaryColor}30, inset 0 1px 0 ${primaryColor}20` : `0 8px 25px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05)`,
      position: 'relative'
    },
    children: [showEmoji && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        fontSize: '0.67em',
        zIndex: 10,
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))',
        animation: isHovered ? 'friterieFloat 1s ease-in-out infinite' : 'none'
      },
      children: emoji
    }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        background: `linear-gradient(135deg, ${priceColor || secondaryColor} 0%, #8b0000 100%)`,
        color: '#fff',
        padding: '6px 14px',
        borderRadius: '20px',
        fontSize: '0.9375em',
        fontWeight: 700,
        fontFamily: "'Fredoka One', cursive",
        boxShadow: `0 3px 15px ${secondaryColor}60`,
        zIndex: 10,
        transform: isHovered ? 'rotate(-3deg) scale(1.1)' : 'rotate(0deg)',
        transition: 'all 0.3s ease'
      },
      children: formatPrice(price)
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        height: imageHeight,
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(180deg, ${accentColor}20 0%, transparent 100%)`
      },
      children: [imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: imageUrl,
        alt: product.name,
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.5s ease',
          transform: isHovered ? 'scale(1.15)' : 'scale(1)',
          filter: isHovered ? 'brightness(1.1) saturate(1.2)' : 'brightness(1)'
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(135deg, ${accentColor}30 0%, ${accentColor}10 100%)`,
          fontSize: '1.33em'
        },
        children: emoji
      }), isHovered && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '10px'
        },
        children: [0, 0.3, 0.6].map((delay, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            width: '8px',
            height: '8px',
            background: 'rgba(255,255,255,0.4)',
            borderRadius: '50%',
            animation: `friterieSteam 1.5s ease-in-out ${delay}s infinite`
          }
        }, i))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: 'linear-gradient(to top, #150c06 0%, transparent 100%)',
          pointerEvents: 'none'
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        padding: '1em'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          margin: 0,
          fontSize: '0.9em',
          fontWeight: 600,
          color: primaryColor,
          fontFamily: "'Fredoka One', cursive",
          marginBottom: '0.5em',
          textShadow: isHovered ? `0 0 10px ${primaryColor}50` : 'none',
          transition: 'text-shadow 0.3s ease'
        },
        children: product.name
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          margin: '0 0 0.75em',
          fontSize: '0.8125em',
          color: `${textColor}80`,
          lineHeight: 1.4,
          fontFamily: "'Georgia', serif",
          fontStyle: 'italic',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        },
        children: product.description
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          gap: '6px',
          alignItems: 'center'
        },
        children: [showTags && product.category?.name && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            padding: '4px 10px',
            background: `${accentColor}40`,
            borderRadius: '12px',
            fontSize: '0.6875em',
            color: primaryColor,
            fontWeight: 600,
            border: `1px solid ${accentColor}`
          },
          children: product.category.name
        }), showNutriScore && product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            padding: '4px 8px',
            background: getNutriScoreColor(product.nutriscore),
            borderRadius: '8px',
            fontSize: '0.6875em',
            fontWeight: 700,
            color: '#fff'
          },
          children: product.nutriscore.toUpperCase()
        }), showAllergens && product.allergens && product.allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            padding: '4px 8px',
            background: `${secondaryColor}30`,
            borderRadius: '8px',
            fontSize: '0.625em',
            color: secondaryColor,
            border: `1px solid ${secondaryColor}50`
          },
          children: ["\u26A0\uFE0F ", product.allergens.length]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          width: '100%',
          marginTop: '0.875em',
          padding: '0.75em',
          background: isHovered ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : `linear-gradient(135deg, ${primaryColor}80 0%, ${secondaryColor}60 100%)`,
          border: 'none',
          borderRadius: '10px',
          color: '#1a0f0a',
          fontSize: '0.58em',
          fontWeight: 700,
          fontFamily: "'Fredoka One', cursive",
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: isHovered ? `0 5px 20px ${primaryColor}50` : `0 3px 10px rgba(0,0,0,0.3)`,
          transform: isHovered ? 'translateY(-2px)' : 'translateY(0)'
        },
        children: buttonText
      })]
    })]
  });
};

// ============================================
// TEMPLATE PIZZERIA - Pizzeria Italienne
// ============================================
const MenuCellPizzeria = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [selectedCategory, setSelectedCategory] = (0, _react.useState)('all');
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [hoveredProduct, setHoveredProduct] = (0, _react.useState)(null);
  const [visibleProducts, setVisibleProducts] = (0, _react.useState)(new Set());
  const [selectedProduct, setSelectedProduct] = (0, _react.useState)(null);
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisables avec valeurs par défaut Pizzeria
  const {
    title = 'La Bella Napoli',
    subtitle = 'Pizzeria Artigianale dal 1985',
    primaryColor = '#c41e3a',
    // Rouge tomate italien
    secondaryColor = '#1a5f1a',
    // Vert basilic
    accentColor = '#f4a020',
    // Jaune doré (mozzarella)
    backgroundColor = '#1a0a05',
    // Brun foncé bois
    textColor = '#fff8e7',
    // Blanc crème
    fontFamily = "'Playfair Display', 'Georgia', serif",
    titleFontSize = '1.6em',
    cardBorderRadius = '12px',
    priceColor = '#f4a020',
    buttonText = '🍕 Ordinare',
    searchPlaceholder = '🔍 Cerca una pizza...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    imageHeight = '140px',
    containerPadding = '1em',
    gridGap = '1em',
    showEmoji = true,
    footerText = 'Fatto con amore ❤️ e farina 00'
  } = normalizedProps;

  // Extraire les catégories
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.category) {
        cats.set(product.category.id || product.category.name, product.category);
      }
      if (product.categories) {
        product.categories.forEach(cat => {
          cats.set(cat.id || cat.name, cat);
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (product.is_active === false) return false;
      if (selectedCategory !== 'all') {
        const hasCategory = product.category?.id === selectedCategory || product.category?.name === selectedCategory || product.categories?.some(c => c.id === selectedCategory || c.name === selectedCategory);
        if (!hasCategory) return false;
      }
      if (searchTerm) {
        const query = searchTerm.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, selectedCategory, searchTerm]);

  // Animation d'entrée progressive
  (0, _react.useEffect)(() => {
    setVisibleProducts(new Set());
    const timer = setTimeout(() => {
      filteredProducts.forEach((product, index) => {
        setTimeout(() => {
          setVisibleProducts(prev => new Set([...prev, product.id]));
        }, index * 80);
      });
    }, 100);
    return () => clearTimeout(timer);
  }, [filteredProducts]);

  // Helpers
  const getDefaultImage = product => {
    if (product.image_uri) return uri_transformer(product.image_uri);
    if (product.image_url) return uri_transformer(product.image_url);
    if (product.images && product.images.length > 0) {
      const img = product.images[0];
      return uri_transformer(img.uri || img.image_url || img.url || img);
    }
    return null;
  };
  const getDefaultPrice = product => {
    if (product.price !== undefined && product.price !== null) return product.price;
    if (product.prices && product.prices.length > 0) {
      if (product.default_price_id) {
        const price = product.prices.find(p => p.id === product.default_price_id);
        if (price) return price.price;
      }
      return product.prices[0]?.price;
    }
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].price;
    }
    return null;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85bb2f',
      'C': '#fecb02',
      'D': '#ee8100',
      'E': '#e63e11'
    };
    return colors[score?.toUpperCase()] || '#999';
  };
  const getProductEmoji = product => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('pizza') || name.includes('margherita') || name.includes('napoli')) return '🍕';
    if (name.includes('pasta') || name.includes('spaghet') || name.includes('penne') || name.includes('lasagne')) return '🍝';
    if (name.includes('tiramisu') || name.includes('panna') || name.includes('dessert') || name.includes('dolce')) return '🍰';
    if (name.includes('vin') || name.includes('vino') || name.includes('wine')) return '🍷';
    if (name.includes('caffè') || name.includes('cafe') || name.includes('espresso')) return '☕';
    if (name.includes('bruschetta') || name.includes('antipast')) return '🥖';
    if (name.includes('insalata') || name.includes('salade')) return '🥗';
    if (name.includes('gelato') || name.includes('glace')) return '🍨';
    if (name.includes('calzone')) return '🥟';
    if (name.includes('focaccia')) return '🫓';
    if (name.includes('olive') || name.includes('huile')) return '🫒';
    if (name.includes('fromage') || name.includes('formaggio') || name.includes('mozza')) return '🧀';
    return '🍽️';
  };
  const handleProductClick = product => {
    setSelectedProduct(product);
  };
  const closeModal = () => {
    setSelectedProduct(null);
  };
  const keyframes = `
        @keyframes pizzeriaFloat {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            25% { transform: translateY(-4px) rotate(1deg); }
            75% { transform: translateY(-2px) rotate(-1deg); }
        }
        @keyframes pizzeriaSlideIn {
            from { opacity: 0; transform: translateY(25px) scale(0.95); }
            to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes pizzeriaGlow {
            0%, 100% { box-shadow: 0 0 15px ${primaryColor}30; }
            50% { box-shadow: 0 0 25px ${primaryColor}50, 0 0 40px ${accentColor}20; }
        }
        @keyframes pizzeriaFlame {
            0%, 100% { opacity: 0.7; transform: scaleY(1); }
            50% { opacity: 1; transform: scaleY(1.1); }
        }
        @keyframes pizzeriaModalIn {
            from { opacity: 0; transform: scale(0.92) translateY(15px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes pizzeriaSpin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
        @keyframes pizzeriaShine {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
        }
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Italiana&display=swap');
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframes
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: containerRef,
      style: {
        height: '100vh',
        background: `
                        radial-gradient(ellipse at top, ${backgroundColor} 0%, #0d0503 100%),
                        repeating-linear-gradient(90deg, transparent 0px, transparent 50px, rgba(139,69,19,0.03) 50px, rgba(139,69,19,0.03) 51px),
                        repeating-linear-gradient(0deg, transparent 0px, transparent 50px, rgba(139,69,19,0.03) 50px, rgba(139,69,19,0.03) 51px)
                    `,
        fontFamily,
        padding: containerPadding,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        fontSize: `${16 * scaleFactor}px` // Base pour tous les em
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${secondaryColor} 33.33%, ${textColor} 33.33%, ${textColor} 66.66%, ${primaryColor} 66.66%)`,
          zIndex: 10
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
        style: {
          textAlign: 'center',
          marginBottom: '1.25em',
          position: 'relative',
          zIndex: 2
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75em',
            marginBottom: '0.5em'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '2em',
              animation: 'pizzeriaSpin 8s linear infinite'
            },
            children: "\uD83C\uDF55"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            style: {
              fontSize: titleFontSize,
              fontWeight: 700,
              color: textColor,
              margin: 0,
              textShadow: `2px 2px 4px rgba(0,0,0,0.5), 0 0 20px ${primaryColor}30`,
              letterSpacing: '2px',
              fontStyle: 'italic'
            },
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '2em',
              animation: 'pizzeriaSpin 8s linear infinite reverse'
            },
            children: "\uD83C\uDF55"
          })]
        }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          style: {
            fontSize: '0.7em',
            color: accentColor,
            margin: 0,
            fontStyle: 'italic',
            letterSpacing: '3px',
            textTransform: 'uppercase'
          },
          children: ["\u2726 ", subtitle, " \u2726"]
        })]
      }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '1em',
          position: 'relative',
          zIndex: 2
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'relative',
            width: '100%',
            maxWidth: '320px'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "text",
            placeholder: searchPlaceholder,
            value: searchTerm,
            onChange: e => setSearchTerm(e.target.value),
            style: {
              width: '100%',
              padding: '0.7em 1em',
              fontSize: '0.6em',
              background: 'rgba(255,248,231,0.08)',
              border: `2px solid ${primaryColor}40`,
              borderRadius: '25px',
              color: textColor,
              outline: 'none',
              fontFamily,
              transition: 'all 0.3s ease'
            }
          })
        })
      }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          overflowX: 'auto',
          gap: '0.5em',
          marginBottom: '1em',
          padding: '0.5em',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PizzeriaCategoryButton, {
          isActive: selectedCategory === 'all',
          onClick: () => setSelectedCategory('all'),
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          accentColor: accentColor,
          children: "\uD83C\uDF7D\uFE0F Tutto"
        }), categories.map((category, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PizzeriaCategoryButton, {
          isActive: selectedCategory === (category.id || category.name),
          onClick: () => setSelectedCategory(category.id || category.name),
          delay: index * 0.05,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          accentColor: accentColor,
          children: category.name
        }, category.id || category.name))]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingRight: '0.25em',
          paddingBottom: '1em',
          WebkitOverflowScrolling: 'touch'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: gridGap
          },
          children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PizzeriaProductCard, {
            product: product,
            isVisible: visibleProducts.has(product.id),
            isHovered: hoveredProduct === product.id,
            onMouseEnter: () => setHoveredProduct(product.id),
            onMouseLeave: () => setHoveredProduct(null),
            onClick: () => handleProductClick(product),
            getDefaultImage: getDefaultImage,
            getDefaultPrice: getDefaultPrice,
            formatPrice: formatPrice,
            getNutriScoreColor: getNutriScoreColor,
            getProductEmoji: getProductEmoji,
            index: index,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            accentColor: accentColor,
            textColor: textColor,
            cardBorderRadius: cardBorderRadius,
            imageHeight: imageHeight,
            priceColor: priceColor,
            buttonText: buttonText,
            showPrice: showPrice,
            showDescription: showDescription,
            showTags: showTags,
            showAllergens: showAllergens,
            showNutriScore: showNutriScore,
            showEmoji: showEmoji,
            scaleFactor: scaleFactor
          }, product.id))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
        style: {
          textAlign: 'center',
          padding: '0.75em 0 0.5em',
          color: `${textColor}60`,
          fontSize: '0.5em',
          fontStyle: 'italic',
          borderTop: `1px solid ${primaryColor}20`,
          flexShrink: 0
        },
        children: footerText
      }), selectedProduct && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductDetailModal.default, {
        product: selectedProduct,
        onClose: closeModal,
        uri_transformer: uri_transformer,
        template_name: "pizzeria",
        styles_properties: styles_properties
      })]
    })]
  });
};

// Bouton catégorie Pizzeria
const PizzeriaCategoryButton = ({
  children,
  isActive,
  onClick,
  delay = 0,
  primaryColor,
  secondaryColor,
  accentColor
}) => {
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      padding: '0.5em 1em',
      fontSize: '0.58em',
      fontWeight: 600,
      fontFamily: "'Playfair Display', Georgia, serif",
      background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : isHovered ? `rgba(255,248,231,0.1)` : 'transparent',
      color: isActive ? '#fff' : '#fff8e7',
      border: `2px solid ${isActive ? primaryColor : 'rgba(255,248,231,0.3)'}`,
      borderRadius: '20px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      transform: isHovered && !isActive ? 'scale(1.03)' : 'scale(1)',
      boxShadow: isActive ? `0 4px 15px ${primaryColor}40` : 'none',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      textTransform: 'capitalize',
      letterSpacing: '0.5px'
    },
    children: children
  });
};

// Carte produit Pizzeria
const PizzeriaProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  getProductEmoji,
  index,
  primaryColor,
  secondaryColor,
  accentColor,
  textColor,
  cardBorderRadius,
  imageHeight,
  priceColor,
  buttonText,
  showPrice,
  showDescription,
  showTags,
  showAllergens,
  showNutriScore,
  showEmoji,
  scaleFactor = 1
}) => {
  const [btnHovered, setBtnHovered] = (0, _react.useState)(false);
  const image = getDefaultImage(product);
  const price = getDefaultPrice(product);
  const tags = product.tags || [];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    style: {
      background: `linear-gradient(145deg, rgba(40,20,10,0.95) 0%, rgba(25,12,6,0.98) 100%)`,
      borderRadius: cardBorderRadius,
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: isVisible ? isHovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
      opacity: isVisible ? 1 : 0,
      boxShadow: isHovered ? `0 12px 30px rgba(0,0,0,0.4), 0 0 20px ${primaryColor}30, inset 0 1px 0 rgba(255,255,255,0.1)` : `0 4px 15px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.05)`,
      border: `1px solid ${isHovered ? primaryColor + '50' : 'rgba(255,248,231,0.1)'}`,
      animation: isVisible ? `pizzeriaSlideIn 0.5s ease ${index * 0.08}s both` : 'none',
      display: 'flex',
      flexDirection: 'column'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'relative',
        height: imageHeight,
        overflow: 'hidden',
        background: `linear-gradient(180deg, rgba(196,30,58,0.1) 0%, transparent 100%)`
      },
      children: [image ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: image,
        alt: product.name,
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.5s ease',
          transform: isHovered ? 'scale(1.08)' : 'scale(1)'
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(135deg, ${primaryColor}20 0%, ${secondaryColor}20 100%)`,
          fontSize: '2.5em'
        },
        children: showEmoji ? getProductEmoji(product) : '🍕'
      }), showEmoji && image && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'rgba(0,0,0,0.7)',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1em',
          border: `2px solid ${accentColor}50`
        },
        children: getProductEmoji(product)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: 'linear-gradient(transparent, rgba(25,12,6,0.9))',
          pointerEvents: 'none'
        }
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: '8px',
          right: '8px',
          background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
          color: '#fff',
          padding: '0.3em 0.6em',
          borderRadius: '15px',
          fontSize: '0.65em',
          fontWeight: 700,
          boxShadow: `0 2px 8px ${primaryColor}50`
        },
        children: formatPrice(price)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        padding: '0.75em',
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          margin: '0 0 0.3em',
          fontSize: '0.7em',
          fontWeight: 600,
          color: textColor,
          fontFamily: "'Playfair Display', Georgia, serif",
          fontStyle: 'italic',
          lineHeight: 1.3
        },
        children: product.name
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          margin: '0 0 0.5em',
          fontSize: '0.5em',
          color: `${textColor}80`,
          lineHeight: 1.4,
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        },
        children: product.description
      }), showTags && tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          gap: '0.25em',
          flexWrap: 'wrap',
          marginTop: 'auto'
        },
        children: tags.slice(0, 2).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            padding: '0.15em 0.4em',
            fontSize: '0.4em',
            background: `${secondaryColor}30`,
            color: secondaryColor,
            borderRadius: '8px',
            border: `1px solid ${secondaryColor}50`
          },
          children: tag
        }, i))
      }), showNutriScore && product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          marginTop: '0.4em',
          display: 'flex',
          alignItems: 'center',
          gap: '0.25em'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.4em',
            color: `${textColor}60`
          },
          children: "Nutri-Score:"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            background: getNutriScoreColor(product.nutriscore),
            color: '#fff',
            padding: '0.1em 0.35em',
            borderRadius: '4px',
            fontSize: '0.4em',
            fontWeight: 700
          },
          children: product.nutriscore.toUpperCase()
        })]
      })]
    })]
  });
};

// ============================================
// TEMPLATE PATISSERIE (Élégant & Gourmand)
// ============================================

const MenuCellPatisserie = ({
  products = [],
  styles_properties = {},
  onProductClick,
  uri_transformer = url => url,
  showCategories = true,
  showFilters = true,
  layout = 'grid',
  columns = 3,
  scaleFactor = 1,
  ...rest
}) => {
  const [activeCategory, setActiveCategory] = (0, _react.useState)('all');
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [hoveredCard, setHoveredCard] = (0, _react.useState)(null);
  const [selectedProduct, setSelectedProduct] = (0, _react.useState)(null);
  const containerRef = (0, _react.useRef)(null);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Couleurs pâtisserie par défaut
  const {
    title = 'Nos Délices',
    subtitle,
    primaryColor = '#d4a5a5',
    // Rose poudré
    secondaryColor = '#8b6f5c',
    // Chocolat
    accentColor = '#f8e1e1',
    // Rose clair
    backgroundColor = '#fdf8f5',
    // Crème
    textColor = '#4a3728',
    // Marron foncé
    fontFamily = '"Playfair Display", Georgia, serif',
    titleFontSize = '2.2em',
    cardBorderRadius = '16px',
    cardBackground = '#ffffff',
    priceColor = '#d4a5a5',
    buttonText = 'Découvrir',
    searchPlaceholder = 'Rechercher une douceur...',
    showPrice = true,
    showDescription = true,
    showTags = true,
    showAllergens = true,
    showNutriScore = true,
    showIngredients = true,
    showEmoji = true,
    imageHeight = '180px',
    containerPadding = '1.5em',
    gridGap = '1.25em'
  } = normalizedProps;

  // Extraire les catégories
  const categories = (0, _react.useMemo)(() => {
    const cats = new Map();
    products.forEach(product => {
      if (product.categories) {
        product.categories.forEach(cat => {
          if (!cats.has(cat.id)) {
            cats.set(cat.id, cat);
          }
        });
      }
    });
    return Array.from(cats.values());
  }, [products]);

  // Filtrer les produits
  const filteredProducts = (0, _react.useMemo)(() => {
    return products.filter(product => {
      if (!product.is_active) return false;
      if (activeCategory !== 'all') {
        const hasCategory = product.categories?.some(c => c.id === activeCategory);
        if (!hasCategory) return false;
      }
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matchName = product.name?.toLowerCase().includes(query);
        const matchDesc = product.description?.toLowerCase().includes(query);
        const matchTags = product.tags?.some(t => t.toLowerCase().includes(query));
        if (!matchName && !matchDesc && !matchTags) return false;
      }
      return true;
    });
  }, [products, activeCategory, searchQuery]);
  const getDefaultImage = product => {
    if (!product.images || product.images.length === 0) return null;
    if (product.default_image_id) {
      const img = product.images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return product.images[0]?.image_url;
  };
  const getDefaultPrice = product => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#22c55e',
      'B': '#84cc16',
      'C': '#eab308',
      'D': '#f97316',
      'E': '#ef4444'
    };
    return colors[score] || secondaryColor;
  };
  const getProductEmoji = product => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('macaron')) return '🧁';
    if (name.includes('éclair') || name.includes('eclair')) return '🥖';
    if (name.includes('tarte')) return '🥧';
    if (name.includes('croissant')) return '🥐';
    if (name.includes('gâteau') || name.includes('gateau') || name.includes('cake')) return '🎂';
    if (name.includes('chocolat')) return '🍫';
    if (name.includes('mille-feuille') || name.includes('millefeuille')) return '🍰';
    if (name.includes('paris-brest')) return '🍩';
    if (name.includes('chou')) return '🧁';
    if (name.includes('fraise') || name.includes('framboise')) return '🍓';
    if (name.includes('citron')) return '🍋';
    if (name.includes('café') || name.includes('coffee')) return '☕';
    return '🧁';
  };
  const handleProductClick = product => {
    setSelectedProduct(product);
  };
  const closeModal = () => {
    setSelectedProduct(null);
  };
  const displaySubtitle = subtitle !== undefined ? subtitle : `${filteredProducts.length} délice${filteredProducts.length > 1 ? 's' : ''}`;

  // Keyframes CSS
  const keyframesCSS = `
        @keyframes patisserieFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
        }
        @keyframes patisserieShine {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
        }
        @keyframes patisseriePulse {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 0.6; }
        }
        @keyframes patisserieFadeIn {
            from { opacity: 0; transform: translateY(20px) scale(0.95); }
            to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .patisserie-scrollable::-webkit-scrollbar {
            width: 8px;
        }
        .patisserie-scrollable::-webkit-scrollbar-track {
            background: ${accentColor}40;
            border-radius: 10px;
        }
        .patisserie-scrollable::-webkit-scrollbar-thumb {
            background: ${primaryColor};
            border-radius: 10px;
        }
        .patisserie-scrollable::-webkit-scrollbar-thumb:hover {
            background: ${secondaryColor};
        }
        /* Scrollbar horizontale pour les catégories */
        .patisserie-categories-scroll::-webkit-scrollbar {
            height: 6px;
        }
        .patisserie-categories-scroll::-webkit-scrollbar-track {
            background: ${accentColor}30;
            border-radius: 10px;
        }
        .patisserie-categories-scroll::-webkit-scrollbar-thumb {
            background: ${primaryColor}80;
            border-radius: 10px;
        }
        .patisserie-categories-scroll::-webkit-scrollbar-thumb:hover {
            background: ${primaryColor};
        }
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    style: {
      fontFamily,
      background: `linear-gradient(135deg, ${backgroundColor} 0%, ${accentColor}40 50%, ${backgroundColor} 100%)`,
      color: textColor,
      height: '100%',
      padding: containerPadding,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative',
      fontSize: `${16 * scaleFactor}px` // Base pour tous les em
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: 0
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `radial-gradient(${primaryColor}15 2px, transparent 2px)`,
          backgroundSize: '30px 30px',
          opacity: 0.5
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        style: {
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '150px',
          opacity: 0.1
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: `M0,100 Q${200},50 ${400},100 T${800},100 T${1200},100`,
          fill: "none",
          stroke: primaryColor,
          strokeWidth: "3"
        })
      })]
    }), showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      style: {
        marginBottom: `calc(1.25em * ${scaleFactor})`,
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.75em'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.5em',
            opacity: 0.6
          },
          children: "\u273F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: {
            fontSize: `calc(${titleFontSize} * ${scaleFactor})`,
            fontWeight: '600',
            margin: 0,
            color: secondaryColor,
            fontStyle: 'italic',
            letterSpacing: '0.02em'
          },
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.5em',
            opacity: 0.6
          },
          children: "\u273F"
        })]
      }), displaySubtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: '0.9em',
          color: `${textColor}90`,
          margin: `calc(0.25em * ${scaleFactor}) 0 calc(1em * ${scaleFactor})`,
          fontStyle: 'italic'
        },
        children: displaySubtitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            position: 'relative',
            width: '100%',
            maxWidth: '350px'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "text",
            placeholder: searchPlaceholder,
            value: searchQuery,
            onChange: e => setSearchQuery(e.target.value),
            style: {
              width: '100%',
              padding: `calc(0.65em * ${scaleFactor}) calc(1em * ${scaleFactor}) calc(0.65em * ${scaleFactor}) calc(2.5em * ${scaleFactor})`,
              fontSize: '0.9em',
              color: textColor,
              background: cardBackground,
              border: `2px solid ${primaryColor}40`,
              borderRadius: '30px',
              outline: 'none',
              boxSizing: 'border-box',
              fontFamily,
              transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
            },
            onFocus: e => {
              e.target.style.borderColor = primaryColor;
              e.target.style.boxShadow = `0 0 15px ${primaryColor}30`;
            },
            onBlur: e => {
              e.target.style.borderColor = `${primaryColor}40`;
              e.target.style.boxShadow = 'none';
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              position: 'absolute',
              left: `calc(1em * ${scaleFactor})`,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '1em',
              opacity: 0.5
            },
            children: "\uD83D\uDD0D"
          })]
        })
      })]
    }), showCategories && categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
      className: "patisserie-categories-scroll",
      style: {
        display: 'flex',
        gap: `calc(0.6em * ${scaleFactor})`,
        overflowX: 'auto',
        overflowY: 'hidden',
        marginBottom: `calc(1.25em * ${scaleFactor})`,
        padding: `calc(0.5em * ${scaleFactor})`,
        position: 'relative',
        zIndex: 1,
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'thin',
        scrollbarColor: `${primaryColor} ${accentColor}40`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PatisserieCategoryButton, {
        isActive: activeCategory === 'all',
        onClick: () => setActiveCategory('all'),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        scaleFactor: scaleFactor,
        children: "\uD83C\uDF70 Tous"
      }), categories.map(category => /*#__PURE__*/(0, _jsxRuntime.jsx)(PatisserieCategoryButton, {
        isActive: activeCategory === category.id,
        onClick: () => setActiveCategory(category.id),
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        scaleFactor: scaleFactor,
        children: category.name
      }, category.id))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "patisserie-scrollable",
      style: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        zIndex: 1
      },
      children: filteredProducts.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: `calc(3em * ${scaleFactor})`,
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: '4em',
            marginBottom: `calc(1em * ${scaleFactor})`,
            animation: 'patisserieFloat 3s ease-in-out infinite'
          },
          children: "\uD83E\uDDC1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            fontSize: '1.4em',
            fontWeight: '500',
            margin: 0,
            color: secondaryColor,
            fontStyle: 'italic'
          },
          children: "Aucune gourmandise trouv\xE9e"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            fontSize: '0.9em',
            color: `${textColor}70`,
            marginTop: `calc(0.5em * ${scaleFactor})`
          },
          children: searchQuery ? "Essayez une autre recherche" : "Cette catégorie est vide pour le moment"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: gridGap
        },
        children: filteredProducts.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(PatisserieProductCard, {
          product: product,
          isVisible: true,
          isHovered: hoveredCard === product.id,
          onMouseEnter: () => setHoveredCard(product.id),
          onMouseLeave: () => setHoveredCard(null),
          onClick: () => handleProductClick(product),
          getDefaultImage: getDefaultImage,
          getDefaultPrice: getDefaultPrice,
          formatPrice: formatPrice,
          getNutriScoreColor: getNutriScoreColor,
          getProductEmoji: getProductEmoji,
          index: index,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          accentColor: accentColor,
          textColor: textColor,
          cardBorderRadius: cardBorderRadius,
          cardBackground: cardBackground,
          imageHeight: imageHeight,
          priceColor: priceColor,
          buttonText: buttonText,
          showPrice: showPrice,
          showDescription: showDescription,
          showTags: showTags,
          showAllergens: showAllergens,
          showNutriScore: showNutriScore,
          showEmoji: showEmoji,
          scaleFactor: scaleFactor,
          uri_transformer: uri_transformer
        }, product.id))
      })
    }), selectedProduct && /*#__PURE__*/(0, _jsxRuntime.jsx)(PatisserieProductModal, {
      product: selectedProduct,
      onClose: closeModal,
      getDefaultImage: getDefaultImage,
      getDefaultPrice: getDefaultPrice,
      formatPrice: formatPrice,
      getNutriScoreColor: getNutriScoreColor,
      getProductEmoji: getProductEmoji,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      accentColor: accentColor,
      backgroundColor: backgroundColor,
      textColor: textColor,
      cardBackground: cardBackground,
      buttonText: buttonText,
      showPrice: showPrice,
      showDescription: showDescription,
      showAllergens: showAllergens,
      showNutriScore: showNutriScore,
      showIngredients: showIngredients,
      scaleFactor: scaleFactor,
      uri_transformer: uri_transformer
    })]
  });
};

// Modal Pâtisserie
const PatisserieProductModal = ({
  product,
  onClose,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  getProductEmoji,
  primaryColor,
  secondaryColor,
  accentColor,
  backgroundColor,
  textColor,
  cardBackground,
  buttonText,
  showPrice,
  showDescription,
  showAllergens,
  showNutriScore,
  showIngredients,
  scaleFactor = 1,
  uri_transformer = url => url
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage(product);
  const price = getDefaultPrice(product);
  const emoji = getProductEmoji(product);
  const modalKeyframes = `
        @keyframes patisserieModalIn {
            from { opacity: 0; transform: scale(0.9) translateY(20px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes patisserieBackdropIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `${textColor}80`,
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: `calc(1em * ${scaleFactor})`,
      boxSizing: 'border-box',
      animation: 'patisserieBackdropIn 0.3s ease-out'
    },
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: modalKeyframes
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        width: '100%',
        maxWidth: `calc(550px * ${scaleFactor})`,
        maxHeight: '90vh',
        background: `linear-gradient(145deg, ${cardBackground} 0%, ${accentColor}30 100%)`,
        borderRadius: `calc(24px * ${scaleFactor})`,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0 25px 50px ${textColor}30`,
        animation: 'patisserieModalIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
        border: `3px solid ${primaryColor}40`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: `calc(1em * ${scaleFactor}) calc(1.25em * ${scaleFactor})`,
          background: `linear-gradient(90deg, ${primaryColor}20, ${accentColor}40, ${primaryColor}20)`,
          borderBottom: `2px solid ${primaryColor}30`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: `calc(0.5em * ${scaleFactor})`
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '1.5em'
            },
            children: emoji
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '0.85em',
              color: secondaryColor,
              fontStyle: 'italic',
              fontFamily: '"Playfair Display", Georgia, serif'
            },
            children: "P\xE2tisserie Fine"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: onClose,
          style: {
            width: `calc(36px * ${scaleFactor})`,
            height: `calc(36px * ${scaleFactor})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.1em',
            color: secondaryColor,
            background: cardBackground,
            border: `2px solid ${primaryColor}40`,
            borderRadius: '50%',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          },
          onMouseEnter: e => {
            e.target.style.background = primaryColor;
            e.target.style.color = '#fff';
          },
          onMouseLeave: e => {
            e.target.style.background = cardBackground;
            e.target.style.color = secondaryColor;
          },
          children: "\u2715"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          position: 'relative',
          height: `calc(280px * ${scaleFactor})`,
          background: `linear-gradient(45deg, ${accentColor}50, ${primaryColor}20)`,
          flexShrink: 0
        },
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            fontSize: '5em'
          },
          children: emoji
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              position: 'absolute',
              left: `calc(0.75em * ${scaleFactor})`,
              top: '50%',
              transform: 'translateY(-50%)',
              width: `calc(40px * ${scaleFactor})`,
              height: `calc(40px * ${scaleFactor})`,
              background: `${cardBackground}ee`,
              border: `2px solid ${primaryColor}`,
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '1em',
              color: secondaryColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              position: 'absolute',
              right: `calc(0.75em * ${scaleFactor})`,
              top: '50%',
              transform: 'translateY(-50%)',
              width: `calc(40px * ${scaleFactor})`,
              height: `calc(40px * ${scaleFactor})`,
              background: `${cardBackground}ee`,
              border: `2px solid ${primaryColor}`,
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '1em',
              color: secondaryColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: `calc(0.75em * ${scaleFactor})`,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: `calc(8px * ${scaleFactor})`
            },
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                width: `calc(10px * ${scaleFactor})`,
                height: `calc(10px * ${scaleFactor})`,
                background: i === currentImageIndex ? primaryColor : `${cardBackground}90`,
                border: `2px solid ${primaryColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                padding: 0
              }
            }, i))
          })]
        }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            top: `calc(1em * ${scaleFactor})`,
            left: `calc(1em * ${scaleFactor})`,
            padding: `calc(0.4em * ${scaleFactor}) calc(0.8em * ${scaleFactor})`,
            background: `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})`,
            color: '#fff',
            borderRadius: `calc(20px * ${scaleFactor})`,
            fontSize: '0.75em',
            fontWeight: '600',
            boxShadow: `0 4px 15px ${secondaryColor}50`
          },
          children: "\u2B50 Coup de c\u0153ur"
        }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            bottom: `calc(1em * ${scaleFactor})`,
            right: `calc(1em * ${scaleFactor})`,
            padding: `calc(0.5em * ${scaleFactor}) calc(1em * ${scaleFactor})`,
            background: cardBackground,
            borderRadius: `calc(12px * ${scaleFactor})`,
            boxShadow: `0 4px 15px ${textColor}20`,
            border: `2px solid ${primaryColor}`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '1.4em',
              fontWeight: '700',
              color: secondaryColor,
              fontFamily: '"Playfair Display", Georgia, serif'
            },
            children: formatPrice(price)
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          flex: 1,
          overflowY: 'auto',
          padding: `calc(1.25em * ${scaleFactor})`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            style: {
              fontSize: '1.5em',
              fontWeight: '600',
              margin: `0 0 calc(0.5em * ${scaleFactor})`,
              color: secondaryColor,
              fontFamily: '"Playfair Display", Georgia, serif',
              fontStyle: 'italic'
            },
            children: product.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              gap: `calc(0.5em * ${scaleFactor})`,
              flexWrap: 'wrap'
            },
            children: [showNutriScore && product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                padding: `calc(0.2em * ${scaleFactor}) calc(0.6em * ${scaleFactor})`,
                fontSize: '0.75em',
                fontWeight: '600',
                background: getNutriScoreColor(product.nutriscore),
                color: '#fff',
                borderRadius: `calc(6px * ${scaleFactor})`
              },
              children: ["Nutri-Score ", product.nutriscore]
            }), product.is_available !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: `calc(0.2em * ${scaleFactor}) calc(0.6em * ${scaleFactor})`,
                fontSize: '0.75em',
                background: '#dcfce7',
                color: '#16a34a',
                borderRadius: `calc(6px * ${scaleFactor})`,
                fontWeight: '500'
              },
              children: "\u2713 Disponible"
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: `calc(0.2em * ${scaleFactor}) calc(0.6em * ${scaleFactor})`,
                fontSize: '0.75em',
                background: '#fee2e2',
                color: '#dc2626',
                borderRadius: `calc(6px * ${scaleFactor})`,
                fontWeight: '500'
              },
              children: "\u2717 Indisponible"
            })]
          })]
        }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`,
            padding: `calc(1em * ${scaleFactor})`,
            background: `${accentColor}40`,
            borderRadius: `calc(12px * ${scaleFactor})`,
            borderLeft: `4px solid ${primaryColor}`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.9em',
              color: textColor,
              lineHeight: 1.7,
              margin: 0,
              fontStyle: 'italic'
            },
            children: product.description
          })
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8em',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: `calc(0.4em * ${scaleFactor})`,
              display: 'flex',
              alignItems: 'center',
              gap: `calc(0.3em * ${scaleFactor})`
            },
            children: "\uD83C\uDFF7\uFE0F Caract\xE9ristiques"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: `calc(0.4em * ${scaleFactor})`,
              flexWrap: 'wrap'
            },
            children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: `calc(0.25em * ${scaleFactor}) calc(0.6em * ${scaleFactor})`,
                fontSize: '0.75em',
                background: cardBackground,
                color: secondaryColor,
                borderRadius: `calc(15px * ${scaleFactor})`,
                border: `1px solid ${primaryColor}50`
              },
              children: tag
            }, i))
          })]
        }), showAllergens && product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`,
            padding: `calc(0.75em * ${scaleFactor})`,
            background: '#fef3c7',
            borderRadius: `calc(10px * ${scaleFactor})`,
            border: '1px solid #fbbf24'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8em',
              fontWeight: '600',
              color: '#92400e',
              marginBottom: `calc(0.4em * ${scaleFactor})`
            },
            children: "\u26A0\uFE0F Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: `calc(0.4em * ${scaleFactor})`,
              flexWrap: 'wrap'
            },
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: `calc(0.2em * ${scaleFactor}) calc(0.5em * ${scaleFactor})`,
                fontSize: '0.75em',
                background: '#fff',
                color: '#b45309',
                borderRadius: `calc(6px * ${scaleFactor})`,
                fontWeight: '500'
              },
              children: allergen.name || allergen
            }, i))
          })]
        }), showIngredients && product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8em',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: `calc(0.4em * ${scaleFactor})`
            },
            children: "\uD83D\uDCDD Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.85em',
              color: `${textColor}90`,
              margin: 0,
              lineHeight: 1.6
            },
            children: product.ingredients.join(' • ')
          })]
        }), showPrice && product.prices?.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: `calc(1em * ${scaleFactor})`
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8em',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: `calc(0.5em * ${scaleFactor})`
            },
            children: "\uD83D\uDCB0 Tarifs"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: `calc(0.6em * ${scaleFactor})`,
              flexWrap: 'wrap'
            },
            children: product.prices.map((p, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                padding: `calc(0.6em * ${scaleFactor}) calc(1em * ${scaleFactor})`,
                background: i === 0 ? `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})` : cardBackground,
                color: i === 0 ? '#fff' : textColor,
                borderRadius: `calc(10px * ${scaleFactor})`,
                textAlign: 'center',
                border: i === 0 ? 'none' : `2px solid ${primaryColor}40`,
                minWidth: `calc(80px * ${scaleFactor})`
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '0.7em',
                  opacity: 0.8
                },
                children: p.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '1.1em',
                  fontWeight: '700',
                  fontFamily: '"Playfair Display", Georgia, serif'
                },
                children: formatPrice(p.price)
              })]
            }, i))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          padding: `calc(1em * ${scaleFactor})`,
          borderTop: `2px solid ${primaryColor}30`,
          background: `linear-gradient(90deg, ${accentColor}30, ${primaryColor}20, ${accentColor}30)`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: `calc(1em * ${scaleFactor})`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.2em'
          },
          children: "\uD83E\uDDC1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.85em',
            color: secondaryColor,
            fontStyle: 'italic',
            fontFamily: '"Playfair Display", Georgia, serif'
          },
          children: "Fait avec amour & passion"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.2em'
          },
          children: "\uD83E\uDDC1"
        })]
      })]
    })]
  });
};

// Bouton catégorie Pâtisserie
const PatisserieCategoryButton = ({
  children,
  isActive,
  onClick,
  primaryColor,
  secondaryColor,
  scaleFactor = 1
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: onClick,
    style: {
      padding: `calc(0.5em * ${scaleFactor}) calc(1.2em * ${scaleFactor})`,
      fontSize: '0.85em',
      fontWeight: isActive ? '600' : '400',
      fontFamily: '"Playfair Display", Georgia, serif',
      fontStyle: 'italic',
      background: isActive ? `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})` : '#fff',
      color: isActive ? '#fff' : secondaryColor,
      border: `2px solid ${isActive ? 'transparent' : primaryColor}40`,
      borderRadius: `calc(25px * ${scaleFactor})`,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: isActive ? `0 4px 15px ${primaryColor}40` : 'none',
      flexShrink: 0,
      whiteSpace: 'nowrap'
    },
    children: children
  });
};

// Carte produit Pâtisserie
const PatisserieProductCard = ({
  product,
  isVisible,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  getDefaultImage,
  getDefaultPrice,
  formatPrice,
  getNutriScoreColor,
  getProductEmoji,
  index,
  primaryColor,
  secondaryColor,
  accentColor,
  textColor,
  cardBorderRadius,
  cardBackground,
  imageHeight,
  priceColor,
  buttonText,
  showPrice,
  showDescription,
  showTags,
  showAllergens,
  showNutriScore,
  showEmoji,
  scaleFactor = 1,
  uri_transformer
}) => {
  const image = getDefaultImage(product);
  const price = getDefaultPrice(product);
  const emoji = getProductEmoji(product);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    style: {
      background: cardBackground,
      borderRadius: cardBorderRadius,
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
      transform: isHovered ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
      boxShadow: isHovered ? `0 20px 40px ${primaryColor}30` : `0 4px 20px ${textColor}10`,
      border: `2px solid ${isHovered ? primaryColor : `${primaryColor}30`}`,
      animation: `patisserieFadeIn 0.6s ease-out ${index * 0.08}s both`
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'relative',
        height: imageHeight,
        background: `linear-gradient(135deg, ${accentColor}60, ${primaryColor}30)`,
        overflow: 'hidden'
      },
      children: [image ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: uri_transformer(image),
        alt: product.name,
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.5s ease',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)'
        },
        loading: "lazy"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          fontSize: '3.5em'
        },
        children: emoji
      }), showEmoji && image && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: `calc(0.5em * ${scaleFactor})`,
          left: `calc(0.5em * ${scaleFactor})`,
          width: `calc(36px * ${scaleFactor})`,
          height: `calc(36px * ${scaleFactor})`,
          background: cardBackground,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.2em',
          boxShadow: `0 2px 10px ${textColor}20`,
          border: `2px solid ${primaryColor}40`
        },
        children: emoji
      }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: `calc(0.5em * ${scaleFactor})`,
          right: `calc(0.5em * ${scaleFactor})`,
          padding: `calc(0.2em * ${scaleFactor}) calc(0.5em * ${scaleFactor})`,
          background: `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})`,
          color: '#fff',
          borderRadius: `calc(10px * ${scaleFactor})`,
          fontSize: '0.65em',
          fontWeight: '600'
        },
        children: "\u2B50 Vedette"
      }), showNutriScore && product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: `calc(0.5em * ${scaleFactor})`,
          left: `calc(0.5em * ${scaleFactor})`,
          padding: `calc(0.15em * ${scaleFactor}) calc(0.4em * ${scaleFactor})`,
          background: getNutriScoreColor(product.nutriscore),
          color: '#fff',
          borderRadius: `calc(4px * ${scaleFactor})`,
          fontSize: '0.7em',
          fontWeight: '700'
        },
        children: product.nutriscore
      }), showPrice && price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: `calc(0.5em * ${scaleFactor})`,
          right: `calc(0.5em * ${scaleFactor})`,
          padding: `calc(0.35em * ${scaleFactor}) calc(0.7em * ${scaleFactor})`,
          background: cardBackground,
          borderRadius: `calc(8px * ${scaleFactor})`,
          boxShadow: `0 2px 10px ${textColor}20`,
          border: `2px solid ${primaryColor}`
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1em',
            fontWeight: '700',
            color: secondaryColor,
            fontFamily: '"Playfair Display", Georgia, serif'
          },
          children: formatPrice(price)
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        padding: `calc(0.9em * ${scaleFactor})`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          fontSize: '1em',
          fontWeight: '600',
          margin: `0 0 calc(0.3em * ${scaleFactor})`,
          color: secondaryColor,
          fontFamily: '"Playfair Display", Georgia, serif',
          fontStyle: 'italic',
          lineHeight: 1.3
        },
        children: product.name
      }), showDescription && product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: '0.8em',
          color: `${textColor}80`,
          margin: `0 0 calc(0.5em * ${scaleFactor})`,
          lineHeight: 1.5,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        },
        children: product.description
      }), showTags && product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          gap: `calc(0.25em * ${scaleFactor})`,
          flexWrap: 'wrap',
          marginBottom: `calc(0.5em * ${scaleFactor})`
        },
        children: product.tags.slice(0, 2).map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            padding: `calc(0.1em * ${scaleFactor}) calc(0.4em * ${scaleFactor})`,
            fontSize: '0.65em',
            background: `${accentColor}60`,
            color: secondaryColor,
            borderRadius: `calc(10px * ${scaleFactor})`
          },
          children: tag
        }, i))
      }), showAllergens && product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          gap: `calc(0.25em * ${scaleFactor})`,
          flexWrap: 'wrap',
          marginBottom: `calc(0.5em * ${scaleFactor})`
        },
        children: product.allergens.slice(0, 2).map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          style: {
            padding: `calc(0.1em * ${scaleFactor}) calc(0.35em * ${scaleFactor})`,
            fontSize: '0.6em',
            background: '#fef3c7',
            color: '#92400e',
            borderRadius: `calc(4px * ${scaleFactor})`
          },
          children: ["\u26A0 ", allergen.name || allergen]
        }, i))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        style: {
          width: '100%',
          padding: `calc(0.55em * ${scaleFactor})`,
          fontSize: '0.85em',
          fontWeight: '500',
          fontFamily: '"Playfair Display", Georgia, serif',
          fontStyle: 'italic',
          color: '#fff',
          background: isHovered ? `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})` : `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
          border: 'none',
          borderRadius: `calc(20px * ${scaleFactor})`,
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: isHovered ? `0 4px 15px ${primaryColor}50` : 'none'
        },
        children: ["\u273F ", buttonText]
      })]
    })]
  });
};
var _default = exports.default = MenuCell;